/* Estudio tresde — asistente paso a paso (modo maqueta + checkout real)
   Flujo: Crea (base → fotos → detalles → propuesta) → Pago → En 3D → Recibe
   Cuenta demo: 3 créditos de prueba sin cuenta → 5 créditos al registrarse.
   Pago: producto real "personaje-personalizado-estudio" vía cart permalink.
   [API] marca los puntos que se conectan al cerebro en V1. */
(function () {
  'use strict';
  if (window.__mtEstudio) return;
  window.__mtEstudio = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var estudio = document.querySelector('[data-mt-estudio]');
    if (!estudio || estudio.hasAttribute('data-mt-listo')) return;
    estudio.setAttribute('data-mt-listo', '1');

    var LS = {
      get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
      set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
      del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
    };

    /* Cuenta NATIVA de Shopify (customer object vía liquid) */
    var cuenta = (function () {
      var d = estudio.getAttribute('data-mt-cliente');
      if (!d) return null;
      var p = d.split('|');
      return { nombre: p[0] || 'Cliente', correo: p[1] || '', id: p[2] || '' };
    })();
    /* Créditos en modo PRUEBAS: 300 (al lanzar se activan los límites reales vía cerebro) */
    var CRED_KEY = cuenta ? 'mtEstudioCred_' + cuenta.id : 'mtEstudioCredInv2';
    var MAX = 4;
    var estado = {
      paso: 1,
      sub1: 'fotos', /* fotos-primero (2026-09-06): permite "Probar otro estilo" sin recargar fotos */
      sub4: 'camino',
      maxPaso: 1,
      creditos: LS.get(CRED_KEY, 300),
      propuestaLista: false,
      pagado: false,
      idDiseno: null,
      urlPropuesta: null
    };

    var stepper = estudio.querySelectorAll('[data-mt-stepper] li');
    var pantallas = estudio.querySelectorAll('[data-mt-pantalla]');
    var btnAtras = estudio.querySelector('[data-mt-atras]');
    var btnSeguir = estudio.querySelector('[data-mt-continuar]');
    var urlCheckout = '';

    var mapaVariantes = null;
    var nodoVariantes = estudio.querySelector('[data-mt-variantes]');
    if (nodoVariantes) { try { mapaVariantes = JSON.parse(nodoVariantes.textContent); } catch (e) {} }

    /* Variante del complemento "Placa con nombre": permite cobrarla en el mismo
       checkout como segunda línea, en vez de dejarla para un ajuste manual. */
    var variantePlaca = null;
    var nodoPlaca = estudio.querySelector('[data-mt-variante-placa]');
    if (nodoPlaca) { variantePlaca = parseInt((nodoPlaca.textContent || '').trim(), 10) || null; }

    /* Pintado a mano: extra con precio por tamaño (variantes del producto oculto
       "Extra: Pintado a mano"); se cobra como otra línea del checkout. */
    var variantesPintado = {};
    var nodoPintado = estudio.querySelector('[data-mt-variantes-pintado]');
    if (nodoPintado) { try { variantesPintado = JSON.parse(nodoPintado.textContent); } catch (e) {} }
    function milesPintado(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function actualizarPrecioPintado() {
      var chk = estudio.querySelector('[data-mt-extra-pintado]');
      if (!chk) return;
      var tamP = seleccion('Tamaño').valor;
      var vp = tamP && variantesPintado[tamP];
      chk.setAttribute('data-mt-extra-precio', vp ? vp.precio : 0);
      var et = estudio.querySelector('[data-mt-precio-pintado]');
      if (!et) return;
      if (vp) { et.textContent = '+$' + milesPintado(vp.precio); return; }
      var lista = Object.keys(variantesPintado).map(function (k) { return variantesPintado[k].precio; });
      if (lista.length) et.textContent = 'desde +$' + milesPintado(Math.min.apply(null, lista));
    }

    /* Cerebro (Cloudflare vía App Proxy): activado desde el editor cuando exista el backend.
       Sin el atributo, todo sigue en modo maqueta como hasta hoy. */
    var CEREBRO = estudio.hasAttribute('data-mt-cerebro');
    var API_BASE = '/apps/personaliza';

    /* Identidad de INVITADO (beta): 3 diseños gratis sin registro. El id vive en
       localStorage y viaja como parámetro; con sesión, Shopify identifica solo. */
    var INVITADO_ID = (function () {
      if (cuenta) return '';
      var v = LS.get('mtEstudioVisitante', null);
      /* segundo ancla: cookie de 1 año (borrar solo localStorage ya no regala créditos;
         el cerebro además limita identidades gratis por IP) */
      var mC = /(?:^|; )mtVisitante=([a-z0-9-]+)/.exec(document.cookie || '');
      if (!v && mC) { v = mC[1]; LS.set('mtEstudioVisitante', v); }
      if (!v) {
        v = 'v-' + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 6);
        LS.set('mtEstudioVisitante', v);
      }
      try { document.cookie = 'mtVisitante=' + v + '; max-age=31536000; path=/; SameSite=Lax; Secure'; } catch (e) {}
      return v;
    })();
    function api(ruta) {
      if (cuenta || !INVITADO_ID) return API_BASE + ruta;
      return API_BASE + ruta + (ruta.indexOf('?') > -1 ? '&' : '?') + 'invitado=' + INVITADO_ID;
    }

    /* Invitado que aún no genera nada: su cuota son 3 diseños — se muestran desde el
       primer pintado (el "0 gratis" inicial desanimaba al tráfico frío). Cubre también
       a quien ya visitó antes y guardó un 0 sin haber generado nunca. */
    if (CEREBRO && !cuenta && !LS.get('mtHaGenerado', null) && !(LS.get(CRED_KEY, 0) > 0)) { estado.creditos = 3; }
    function urlConInvitado(u) {
      if (cuenta || !INVITADO_ID || !u || u.indexOf('/img/') === -1) return u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'invitado=' + INVITADO_ID;
    }

    /* El paso "En 3D" se retiró (2026-08-30): la vista 3D de la pieza comprada
       llegará más adelante; hoy el flujo es Crea → Pago → Recibe. */
    var ESTADOS_TARJETA = { 1: 'Diseñando…', 2: 'Por confirmar', 4: 'En producción ✦' };

    function guardarCreditos() {
      LS.set(CRED_KEY, estado.creditos);
    }

    /* ───────── Selecciones ───────── */
    function seleccion(nombre) {
      var g = estudio.querySelector('[data-mt-grupo="' + nombre + '"] [data-mt-eleccion].mt-activa');
      return g ? { valor: g.getAttribute('data-mt-eleccion'), precio: g.getAttribute('data-mt-precio'), hex: g.getAttribute('data-mt-hex'), img: g.getAttribute('data-mt-img'), brillo: g.getAttribute('data-mt-brillo') } : {};
    }
    var GRUPOS = ['Tipo', 'Estilo', 'Tamaño', 'Color'];
    var GRUPOS_RES = GRUPOS.concat(['Pose', 'Base']); /* Pose y Base no bloquean el avance */

    /* Extras de la base (upsell): suman al precio */
    function extrasElegidos() {
      var lista = [];
      estudio.querySelectorAll('[data-mt-extra]:checked').forEach(function (ex) {
        lista.push({
          nombre: ex.getAttribute('data-mt-extra'),
          precio: Number(ex.getAttribute('data-mt-extra-precio')) || 0
        });
      });
      return lista;
    }
    function precioExtras() {
      return extrasElegidos().reduce(function (s, e) { return s + e.precio; }, 0);
    }
    function faltantes() { return GRUPOS.filter(function (n) { return !seleccion(n).valor; }); }
    function fotosCargadas() { return estudio.querySelectorAll('[data-mt-foto].mt-cargada').length; }

    /* ───────── Sub-pasos (Crea y Recibe) ───────── */
    function irSub(nombre) {
      if (estado.paso === 4) {
        estado.sub4 = nombre;
        subpantalla(4, nombre);
        if (nombre === 'pedidos') pintarPedidos();
      } else {
        estado.sub1 = nombre;
        subpantalla(1, nombre);
        if (nombre === 'detalles') pintarSugerencias();
      }
      pintar();
      guardarEstadoCompleto();
      alInicio();
    }
    estudio.addEventListener('click', function (e) {
      var volver = e.target.closest('[data-mt-sub-ir]');
      if (volver) irSub(volver.getAttribute('data-mt-sub-ir'));
    });

    /* Cada paso arranca arriba del todo (lienzo interno y página) */
    function alInicio() {
      var lienzo = estudio.querySelector('.mt-estudio__lienzo');
      var suave = reduceMotion ? 'auto' : 'smooth';
      if (lienzo) { try { lienzo.scrollTo({ top: 0, behavior: suave }); } catch (e) { lienzo.scrollTop = 0; } }
      var barra = estudio.querySelector('.mt-estudio__barra');
      if (barra && barra.getBoundingClientRect().top < 0) {
        try { estudio.scrollIntoView({ block: 'start', behavior: suave }); } catch (e) { estudio.scrollIntoView(); }
      }
    }

    /* ───────── Navegación entre pasos ───────── */
    function pista() {
      if (estado.paso === 1) {
        if (estado.sub1 === 'base') {
          var f = faltantes();
          return f.length ? 'Elige: ' + f.join(', ').toLowerCase() : 'Base lista ✓';
        }
        if (estado.sub1 === 'fotos') {
          if (fotosCargadas() >= 1 && !permisoDado()) return 'Falta marcar el permiso de imagen';
          return 'Sube tus fotos (' + fotosCargadas() + '/4)';
        }
        if (estado.sub1 === 'detalles') return 'Genera tu propuesta para continuar';
        if (estado.sub1 === 'generando') return 'La IA está esculpiendo tu propuesta…';
        return '';
      }
      if (estado.paso === 2) return estado.pagado ? '' : 'Confirma tu pedido para entrar a producción';
      if (estado.paso === 4) return estado.sub4 === 'camino' ? 'Sigue tus pedidos desde tu perfil' : '';
      return '';
    }

    function pintar() {
      pantallas.forEach(function (p) {
        var n = p.getAttribute('data-mt-pantalla');
        var activa = n === String(estado.paso);
        p.hidden = !activa;
        p.classList.toggle('mt-visible-p', activa);
      });
      stepper.forEach(function (li) {
        var n = Number(li.getAttribute('data-mt-ir'));
        li.classList.toggle('mt-activo', n === estado.paso);
        li.classList.toggle('mt-hecho', n < estado.paso);
      });
      /* con pago confirmado no hay a dónde regresar (el paso de pago ya cerró) */
      btnAtras.disabled = estado.paso === 1 || (estado.paso === 4 && estado.pagado);
      btnSeguir.disabled = !puedeAvanzar();
      btnSeguir.hidden = estado.paso === MAX && estado.sub4 === 'pedidos';
      var elPista = estudio.querySelector('[data-mt-pista]');
      if (elPista) { var t = pista(); elPista.textContent = t; elPista.hidden = !t; }
      var chip = estudio.querySelector('[data-mt-tarjeta-estado]');
      if (chip) {
        chip.textContent = estado.paso === 2 && estado.pagado ? 'Pagado ✓' : ESTADOS_TARJETA[estado.paso];
        chip.classList.toggle('mt-ok', estado.pagado);
      }
      actualizarResumen();
      actualizarGate();
      pintarCuenta();
    }

    function puedeAvanzar() {
      if (estado.paso === 1) {
        if (estado.sub1 === 'base') return !faltantes().length;
        if (estado.sub1 === 'fotos') return fotosCargadas() >= 1 && permisoDado();
        return false;
      }
      if (estado.paso === 2) return estado.pagado;
      if (estado.paso === 4) return estado.sub4 === 'camino';
      return false;
    }

    function ir(n) {
      n = Math.max(1, Math.min(MAX, n));
      /* El paso 3 (En 3D) ya no existe: pagado → Recibe; sin pagar → Pago.
         Cubre también estados viejos guardados en localStorage con paso 3. */
      if (n === 3) n = estado.pagado ? 4 : 2;
      estado.paso = n;
      estado.maxPaso = Math.max(estado.maxPaso, estado.paso);
      if (estado.paso === 1) {
        subpantalla(1, estado.sub1);
        if (estado.sub1 === 'detalles') pintarSugerencias();
      }
      if (estado.paso === 2) {
        subpantalla(2, estado.pagado ? 'exito' : 'revisar');
        pintarExtrasFicha();
      }
      if (estado.paso === 4) { subpantalla(4, estado.sub4); if (estado.sub4 === 'pedidos') pintarPedidos(); pintarRuta(); }
      pintar();
      guardarEstadoCompleto();
      alInicio();
    }

    btnSeguir.addEventListener('click', function () {
      if (estado.paso === 1) {
        if (estado.sub1 === 'fotos') { intentarFotosSeguir(); return; }
        if (estado.sub1 === 'base') { if (!faltantes().length) irSub('detalles'); return; }
        return;
      }
      if (estado.paso === 4) {
        if (estado.sub4 === 'camino') irSub('pedidos');
        return;
      }
      ir(estado.paso + 1);
    });
    btnAtras.addEventListener('click', function () { ir(estado.paso - 1); });
    /* Stepper superior BLOQUEADO (decisión 2026-08-09): el flujo se hace de
       corrido; al final se compra o se usa "Volver a empezar". Sin atajos. */
    stepper.forEach(function (li) {
      li.setAttribute('aria-disabled', 'true');
      li.style.cursor = 'default';
    });

    /* Cabeza/Busto → gestos faciales · Cuerpo completo → poses corporales.
       Ambas listas comparten data-mt-grupo="Pose": solo la visible conserva
       la selección activa, así seleccion('Pose') siempre lee la correcta. */
    function ajustarListaPose() {
      var lp = estudio.querySelector('[data-mt-lista-poses]');
      var lg = estudio.querySelector('[data-mt-lista-gestos]');
      if (!lp || !lg) return;
      var tipo = seleccion('Tipo').valor;
      var mostrar = (!tipo || tipo === 'Cuerpo completo') ? lp : lg;
      var ocultar = mostrar === lp ? lg : lp;
      mostrar.hidden = false;
      ocultar.hidden = true;
      var titulo = estudio.querySelector('[data-mt-pose-titulo]');
      if (titulo) {
        titulo.textContent = titulo.getAttribute(mostrar === lp ? 'data-mt-t-pose' : 'data-mt-t-gesto');
      }
      /* traspasa la selección a la lista visible (mismo nombre si existe; si no, la primera) */
      var previa = ocultar.querySelector('.mt-activa');
      if (!mostrar.querySelector('.mt-activa')) {
        var equivalente = previa
          ? mostrar.querySelector('[data-mt-eleccion="' + CSS.escape(previa.getAttribute('data-mt-eleccion')) + '"]')
          : null;
        var destino = equivalente || mostrar.querySelector('[data-mt-eleccion]');
        if (destino) destino.classList.add('mt-activa');
      }
      if (previa) previa.classList.remove('mt-activa');
    }

    /* Reglas cruzadas de selección: 'Sin base' solo aplica a Cuerpo completo;
       Realista y Art toy de cuerpo completo solo desde 20 cm (decisión R2:
       en tamaños chicos esos cuerpos pierden el parecido al imprimir) */
    function ajustarReglasSeleccion() {
      var tipo = seleccion('Tipo').valor;
      var estilo = seleccion('Estilo').valor;
      var esCC = tipo === 'Cuerpo completo';
      var sinBase = estudio.querySelector('[data-mt-grupo="Base"] [data-mt-eleccion="Sin base"]');
      if (sinBase) {
        sinBase.hidden = !esCC;
        if (!esCC && sinBase.classList.contains('mt-activa')) {
          sinBase.classList.remove('mt-activa');
          var circ = estudio.querySelector('[data-mt-grupo="Base"] [data-mt-eleccion="Circular clásica"]');
          if (circ) circ.classList.add('mt-activa');
        }
      }
      /* Tipos de pieza permitidos por estilo (lista de Octavio, 2026-08-22) */
      var TIPOS_POR_ESTILO = {
        'Anime': ['Cuerpo completo', 'Cabeza', 'Busto'],
        'Animado tipo película': ['Cuerpo completo', 'Cabeza', 'Busto'],
        'Chibi': ['Cuerpo completo', 'Cabeza'],
        'Art toy': ['Cuerpo completo', 'Cabeza', 'Busto'],
        'Realista': ['Cabeza', 'Busto'],
        'Cúbico': ['Cabeza', 'Busto'],
        'Cabezón': ['Cuerpo completo'],
        'Low poly': ['Cuerpo completo', 'Cabeza', 'Busto'],
        'Origami': ['Cabeza', 'Busto']
      };
      var permitidos = TIPOS_POR_ESTILO[estilo] || ['Cuerpo completo', 'Cabeza', 'Busto'];
      var cambioTipo = false;
      estudio.querySelectorAll('[data-mt-grupo="Tipo"] [data-mt-eleccion]').forEach(function (p) {
        var v = p.getAttribute('data-mt-eleccion');
        var ok = permitidos.indexOf(v) > -1;
        p.disabled = !ok;
        p.classList.toggle('mt-no-disponible', !ok);
        p.title = ok ? '' : ('El estilo ' + estilo + ' no está disponible en ' + v);
        if (!ok && p.classList.contains('mt-activa')) { p.classList.remove('mt-activa'); cambioTipo = true; }
      });
      if (cambioTipo || (estilo && !tipo)) {
        var primero = estudio.querySelector('[data-mt-grupo="Tipo"] [data-mt-eleccion="' + CSS.escape(permitidos[0]) + '"]');
        if (primero) { primero.classList.add('mt-activa'); tipo = permitidos[0]; esCC = tipo === 'Cuerpo completo'; ajustarListaPose(); }
      }
      var notaTipo = estudio.querySelector('[data-mt-nota-tipo]');
      if (notaTipo) {
        notaTipo.hidden = !estilo || permitidos.length === 3;
        if (estilo && permitidos.length < 3) notaTipo.textContent = estilo + ' se ofrece en: ' + permitidos.join(' · ');
      }
      var restringe = esCC && (estilo === 'Realista' || estilo === 'Art toy');
      estudio.querySelectorAll('[data-mt-grupo="Tamaño"] [data-mt-eleccion]').forEach(function (p) {
        var v = p.getAttribute('data-mt-eleccion');
        var bloquear = restringe && (v === '10 cm' || v === '15 cm');
        p.disabled = bloquear;
        if (bloquear && p.classList.contains('mt-activa')) p.classList.remove('mt-activa');
      });
      var notaT = estudio.querySelector('[data-mt-nota-tamano]');
      if (notaT) notaT.hidden = !restringe;
      ajustarPlacaSegunBase();
    }

    /* "Sin base" no admite placa grabada (la placa vive en la base) — reporte
       Octavio 2026-08-30: se desmarca y deshabilita el extra mientras dure */
    function ajustarPlacaSegunBase() {
      var chk = estudio.querySelector('[data-mt-extra="Placa con nombre"]');
      if (!chk) return;
      var sinBase = seleccion('Base').valor === 'Sin base';
      var caja = chk.closest('.mt-estudio__extra');
      if (sinBase && chk.checked) {
        chk.checked = false;
        chk.dispatchEvent(new Event('change', { bubbles: true })); /* oculta el campo y recalcula el precio */
      }
      chk.disabled = sinBase;
      if (caja) {
        caja.classList.toggle('mt-no-disponible', sinBase);
        caja.title = sinBase ? 'La placa se graba en la base — elige una base para añadirla' : '';
      }
      var campo = estudio.querySelector('[data-mt-placa-texto]');
      if (sinBase && campo) campo.hidden = true;
    }

    /* ───────── Píldoras (con Multicolor "próximamente") ───────── */
    estudio.addEventListener('click', function (e) {
      var pil = e.target.closest('[data-mt-grupo] [data-mt-eleccion], [data-mt-grupo] [data-mt-proximamente]');
      if (!pil) return;
      if (pil.hasAttribute('data-mt-agotado')) return;
      if (pil.hasAttribute('data-mt-proximamente')) {
        var nodoM = infoNodo('Color', 'Multicolor');
        if (nodoM) abrirModal('Multicolor', '<div class="mt-modal-estudio__rejilla mt-modal-estudio__rejilla--una">' + tarjetaInfoHTML(nodoM, false) + '</div>');
        return;
      }
      var grupo = pil.closest('[data-mt-grupo]');
      grupo.querySelectorAll('[data-mt-eleccion]').forEach(function (p) { p.classList.remove('mt-activa'); });
      pil.classList.add('mt-activa');
      var nombreGrupo = grupo.getAttribute('data-mt-grupo');
      if (nombreGrupo === 'Tipo') ajustarListaPose();
      if (nombreGrupo === 'Tipo' || nombreGrupo === 'Estilo') ajustarReglasSeleccion();
      if (nombreGrupo === 'Base') ajustarPlacaSegunBase();
      pintar();
      guardarSelecciones();
    });

    var btnBaseSeguir = estudio.querySelector('[data-mt-base-seguir]');
    if (btnBaseSeguir) {
      btnBaseSeguir.addEventListener('click', function () {
        if (!faltantes().length) irSub('detalles');
      });
    }

    function actualizarResumen() {
      GRUPOS_RES.forEach(function (n) {
        estudio.querySelectorAll('[data-mt-res="' + n + '"]').forEach(function (res) {
          res.textContent = seleccion(n).valor || '—';
        });
      });
      var hex = seleccion('Color').hex;
      estudio.querySelectorAll('[data-mt-res-dot]').forEach(function (d) { d.style.background = hex || '#555'; });
      var thumbColor = estudio.querySelector('[data-mt-thumb-color]');
      if (thumbColor) thumbColor.style.setProperty('--c', hex || '#5a5a5a');
      /* Vista previa del ACABADO real (24 figuras impresas, 2026-08-22): mientras no
         hay propuesta, la tarjeta muestra la figura en blanco del color elegido */
      var thumbAc = estudio.querySelector('[data-mt-thumb-acabado]');
      var baseAc = estudio.getAttribute('data-mt-acabados-base') || '';
      var imgColor = seleccion('Color').img;
      if (thumbAc && imgColor && !estado.propuestaLista) {
        thumbAc.src = imgColor;
        thumbAc.hidden = false;
        if (thumbColor) thumbColor.hidden = true;
      } else if (thumbAc) {
        thumbAc.hidden = true;
        if (thumbColor && !estado.propuestaLista) thumbColor.hidden = false;
      }
      var precio = seleccion('Tamaño').precio;
      actualizarPrecioPintado();
      var total = precio ? Number(precio) + precioExtras() : null;
      var texto;
      if (total) {
        texto = '$' + String(total).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
      } else {
        /* aún sin tamaño: mostrar el precio de arranque */
        var precios = Array.prototype.map.call(
          estudio.querySelectorAll('[data-mt-grupo="Tamaño"] [data-mt-precio]'),
          function (p) { return Number(p.getAttribute('data-mt-precio')); }
        ).filter(Boolean);
        var min = precios.length ? Math.min.apply(null, precios) : null;
        texto = min ? 'desde $' + String(min).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN' : '—';
      }
      estudio.querySelectorAll('[data-mt-precio-estimado]').forEach(function (v) { v.textContent = texto; });
      var cred = estudio.querySelector('[data-mt-creditos]');
      if (cred) cred.textContent = estado.creditos + (CEREBRO ? (estado.creditos === 1 ? (cuenta ? ' crédito' : ' gratis') : (cuenta ? ' créditos' : ' gratis')) : ' de prueba');
      estudio.setAttribute('data-mt-paso', estado.paso);
      pintarExtrasFicha();
    }

    /* ───────── Fotos: validación real ───────── */
    var slotsFoto = estudio.querySelectorAll('[data-mt-foto]');

    function validarImagen(archivo, alTerminar) {
      if (!archivo.type || archivo.type.indexOf('image/') !== 0) {
        return alTerminar({ nivel: 'error', msg: 'Ese archivo no es una imagen' });
      }
      if (archivo.size > 15 * 1024 * 1024) {
        return alTerminar({ nivel: 'error', msg: 'Muy pesada: máximo 15 MB' });
      }
      var url = URL.createObjectURL(archivo);
      var im = new Image();
      im.onload = function () {
        var lado = Math.min(im.naturalWidth, im.naturalHeight);
        if (lado < 500) {
          alTerminar({ nivel: 'alerta', msg: 'Se ve pequeña (' + im.naturalWidth + '×' + im.naturalHeight + ') — mejor ≥ 800 px', url: url });
        } else {
          alTerminar({ nivel: 'ok', msg: '✓ Se ve bien', url: url });
        }
      };
      im.onerror = function () { alTerminar({ nivel: 'error', msg: 'No pudimos leerla: usa JPG o PNG' }); };
      im.src = url;
    }

    function actualizarGate() {
      var cargadas = fotosCargadas();
      var f = faltantes();
      var baseNota = estudio.querySelector('[data-mt-base-nota]');
      if (baseNota) {
        baseNota.textContent = f.length
          ? (4 - f.length) + ' de 4 categorías listas — falta: ' + f.join(', ').toLowerCase()
          : '¡Base lista! Continúa a tus fotos';
        if (!f.length) baseNota.classList.add('mt-oro-texto'); else baseNota.classList.remove('mt-oro-texto');
      }
      var btnBase = estudio.querySelector('[data-mt-base-seguir]');
      if (btnBase) btnBase.disabled = f.length > 0;
      var conteoF = estudio.querySelector('[data-mt-fotos-conteo]');
      if (conteoF) {
        conteoF.textContent = cargadas === 0
          ? 'Sube al menos 1 foto (con las 4 logramos el mejor parecido)'
          : cargadas < 4
            ? 'Llevas ' + cargadas + ' de 4 — puedes continuar, aunque recomendamos las 4'
            : '¡Las 4 fotos listas! El mejor parecido asegurado ✓';
      }
      var btnF = estudio.querySelector('[data-mt-fotos-seguir]');
      if (btnF) btnF.disabled = cargadas < 1 || !permisoDado();
      if (conteoF && cargadas >= 1 && !permisoDado()) {
        conteoF.textContent = 'Marca la casilla de permiso para continuar';
      }
      var notaG = estudio.querySelector('[data-mt-generar-nota]');
      if (notaG) {
        notaG.textContent = estado.creditos < 1
          ? (cuenta ? 'Sin créditos — consigue más en la tienda' : 'Sin créditos — crea tu cuenta y recibe 3 más')
          : 'La generación usa 1 crédito · te quedan ' + estado.creditos;
      }
      var btnG = estudio.querySelector('[data-mt-generar]');
      if (btnG) btnG.disabled = f.length > 0 || cargadas < 1;
      var tira = estudio.querySelector('[data-mt-tarjeta-fotos]');
      if (tira) {
        tira.hidden = cargadas === 0;
        var minis = tira.querySelectorAll('img');
        slotsFoto.forEach(function (slot, i) {
          var src = slot.classList.contains('mt-cargada') ? slot.querySelector('img').src : '';
          if (minis[i]) { minis[i].src = src; minis[i].hidden = !src; }
        });
      }
    }

    slotsFoto.forEach(function (slot) {
      var input = slot.querySelector('input[type="file"]');
      var img = slot.querySelector('img');
      var badge = slot.querySelector('[data-mt-foto-estado]');
      input.addEventListener('change', function (ev) {
        if (!input.files || !input.files[0]) return;
        /* carga MANUAL (evento confiable del navegador) = las tomas 3/4 del escáner
           ya no corresponden a estas fotos → se descartan */
        if (ev && ev.isTrusted && Array.isArray(window.__mtEscaneoExtra)) window.__mtEscaneoExtra = [];
        if (badge) { badge.hidden = false; badge.textContent = 'Revisando…'; }
        validarImagen(input.files[0], function (res) {
          slot.classList.remove('mt-alerta', 'mt-error');
          if (res.nivel === 'error') {
            input.value = '';
            img.hidden = true;
            slot.classList.remove('mt-cargada');
            slot.classList.add('mt-error');
          } else {
            img.src = res.url;
            img.hidden = false;
            slot.classList.add('mt-cargada');
            if (res.nivel === 'alerta') slot.classList.add('mt-alerta');
          }
          if (badge) { badge.textContent = res.msg; badge.hidden = false; }
          pintar();
        });
      });
    });

    /* Extras de la base: recalculan precio y muestran el campo de la placa */
    estudio.addEventListener('change', function (e) {
      var ex = e.target.closest('[data-mt-extra]');
      if (!ex) return;
      if (ex.getAttribute('data-mt-extra') === 'Placa con nombre') {
        var campo = estudio.querySelector('[data-mt-placa-texto]');
        if (campo) {
          campo.hidden = !ex.checked;
          if (ex.checked) campo.focus();
        }
      }
      pintar();
      guardarSelecciones();
    });

    /* Casilla de permiso de imagen: obligatoria para continuar */
    var permiso = estudio.querySelector('[data-mt-permiso]');
    if (permiso) {
      permiso.addEventListener('change', function () { pintar(); guardarSelecciones(); });
    }
    function permisoDado() { return !permiso || permiso.checked; }

    /* Continuar de fotos → detalles (aviso si van pocas) */
    var modalFotos = estudio.querySelector('[data-mt-modal-fotos]');
    function intentarFotosSeguir() {
      if (fotosCargadas() < 1 || !permisoDado()) return;
      if (fotosCargadas() < 4 && modalFotos) {
        modalFotos.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      } else {
        irSub('base');
      }
    }
    var btnFotosSeguir = estudio.querySelector('[data-mt-fotos-seguir]');
    if (btnFotosSeguir) btnFotosSeguir.addEventListener('click', intentarFotosSeguir);
    var btnFotosAsi = estudio.querySelector('[data-mt-fotos-continuar-asi]');
    if (btnFotosAsi) {
      btnFotosAsi.addEventListener('click', function () {
        cerrarModales();
        irSub('base');
      });
    }

    /* ───────── Mis pedidos (Mi perfil, demo) ───────── */
    /* Línea de producción del paso 4 con el estado REAL (diseño + pedido) */
    function pintarRuta() {
      var hitos = estudio.querySelectorAll('[data-mt-ruta] [data-mt-hito]');
      if (!hitos.length) return;
      var etapa = (estado.pedido && estado.pedido.etapa) || 'confirmado';
      var orden = ['configurada', 'aprobado', 'pagado', 'modelado_3d', 'cola_impresion', 'imprimiendo', 'calidad', 'enviado'];
      var nivel = { confirmado: 2, modelado_3d: 3, cola_impresion: 4, imprimiendo: 5, calidad: 6, enviado: 7 }[etapa];
      if (nivel === undefined) nivel = 2;
      if (!estado.pagado) nivel = 1;
      hitos.forEach(function (h) {
        var i = orden.indexOf(h.getAttribute('data-mt-hito'));
        h.classList.toggle('mt-hecho', i <= nivel);
        h.classList.toggle('mt-siguiente', i === nivel + 1);
      });
      var im = estudio.querySelector('[data-mt-ruta-img]');
      if (im && estado.urlPropuesta) { im.src = estado.urlPropuesta; im.hidden = false; }
      var titulo = estudio.querySelector('[data-mt-ruta-estado]');
      if (titulo) titulo.textContent = ({ 1: 'esperando tu pago', 2: 'confirmada', 3: 'modelada en 3D', 4: 'en cola de impresión', 5: 'imprimiéndose', 6: 'en control de calidad', 7: 'en camino' })[nivel] || 'en camino';
    }
    function pintarPedidos() {
      var caja = estudio.querySelector('[data-mt-pedidos-cuenta]');
      var btnCrearP = estudio.querySelector('[data-mt-pedidos-crear]');
      if (caja) {
        caja.textContent = cuenta
          ? '◉ ' + cuenta.nombre + ' · ' + cuenta.correo
          : 'Crea tu cuenta para guardar tus pedidos y diseños';
      }
      if (btnCrearP) btnCrearP.hidden = !!cuenta;
      cargarHistorial();
    }

    function esc(t) {
      var d = document.createElement('span');
      d.textContent = t == null ? '' : String(t);
      return d.innerHTML;
    }

    /* Historial real de diseños (cerebro): tarjetas compartidas entre el paso
       4.2 y el modal "Mis diseños" de la barra (accesible SIN comprar) */
    var historialCache = {};
    function htmlHistorial(ds) {
      return ds.map(function (x) {
        historialCache[x.id] = x;
        var c = x.config || {};
        return '<div class="mt-estudio__pedido">' +
          (x.url_imagen ? '<img src="' + esc(urlConInvitado(x.url_imagen)) + '" alt="Diseño ' + esc(x.id) + '" width="90" height="90" loading="lazy">' : '') +
          '<div class="mt-estudio__pedido-info">' +
          '<b>Diseño <span class="mt-oro-texto">' + esc(x.id) + '</span></b>' +
          '<div class="mt-estudio__etiquetas">' +
          ['Tipo', 'Estilo', 'Tamaño', 'Color'].map(function (k) {
            return c[k] ? '<span class="mt-etq">' + esc(c[k]) + '</span>' : '';
          }).join('') +
          '</div>' +
          '<span class="mt-estudio__pedido-estado">' + esc((x.creado || '').slice(0, 10)) + '</span>' +
          '</div>' +
          '<button type="button" class="mt-estudio__cual" data-mt-retomar="' + esc(x.id) + '">Retomar →</button>' +
          '</div>';
      }).join('');
    }
    function cargarHistorial() {
      if (!CEREBRO) return;
      var caja = estudio.querySelector('[data-mt-historial]');
      var lista = estudio.querySelector('[data-mt-historial-lista]');
      if (!caja || !lista) return;
      fetch(api('/disenos'))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ds = (d && d.disenos) || [];
          if (!ds.length) return;
          caja.hidden = false;
          var demo = estudio.querySelector('[data-mt-pedido-demo]');
          if (demo) demo.hidden = true;
          lista.innerHTML = htmlHistorial(ds);
        })
        .catch(function () {});
    }

    /* Retomar un diseño anterior: restaura selecciones + propuesta y va a la ficha */
    estudio.addEventListener('click', function (e) {
      var ret = e.target.closest('[data-mt-retomar]');
      if (!ret) return;
      var x = historialCache[ret.getAttribute('data-mt-retomar')];
      if (!x) return;
      var btnCerrarM = document.querySelector('[data-mt-modal-cerrar]');
      if (btnCerrarM && ret.closest('[data-mt-historial-modal]')) btnCerrarM.click();
      aplicarRetomar(x);
    });

    /* Retomar un diseño (desde el modal, el 4.2 o el enlace ?retomar= del perfil) */
    function aplicarRetomar(x) {
      var c = x.config || {};
      ['Tipo', 'Estilo', 'Tamaño', 'Color', 'Pose', 'Base'].forEach(function (g) {
        if (!c[g]) return;
        estudio.querySelectorAll('[data-mt-grupo="' + g + '"] [data-mt-eleccion]').forEach(function (p) {
          p.classList.remove('mt-activa');
        });
        var pil = estudio.querySelector('[data-mt-grupo="' + g + '"] [data-mt-eleccion="' + CSS.escape(c[g]) + '"]');
        if (pil) pil.classList.add('mt-activa');
      });
      ajustarListaPose();
      ajustarReglasSeleccion();
      estado.idDiseno = x.id;
      estado.propuestaLista = true;
      if (x.url_imagen) aplicarPropuesta(urlConInvitado(x.url_imagen));
      marcarDiseno();
      estado.maxPaso = Math.max(estado.maxPaso, 2);
      if (x.config && x.config.placa) restaurarExtras(x.config.placa, x.config.notas);
      guardarSelecciones();
      if (x.pagado) {
        /* diseño ya pagado: directo a su estatus de producción, sin volver a cobrar */
        estado.pagado = true;
        estado.pedido = x.pedido || null;
        estado.maxPaso = 4;
        guardarEstadoCompleto();
        ir(4);
        return;
      }
      guardarEstadoCompleto();
      ir(2);
    }

    /* El acceso a los diseños vive ahora en el enlace "Mi Estudio" de la barra
       (hub /pages/mi-estudio), igual que en el header de la tienda */

    /* Créditos reales del cerebro (fuente de verdad cuando está conectado) */
    function sincronizarCreditos() {
      if (!CEREBRO) return;
      fetch(api('/creditos'))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && typeof d.creditos === 'number' && (d.registrado || !cuenta)) {
            /* Un invitado que aún no genera nada conserva el "3 gratis" visual:
               el cerebro puede responder 0 antes de conocer a esta identidad */
            if (d.creditos === 0 && !cuenta && !LS.get('mtHaGenerado', null)) return;
            estado.creditos = d.creditos;
            guardarCreditos();
            pintar();
          }
        })
        .catch(function () {});
    }
    var btnVerPedidos = estudio.querySelector('[data-mt-ver-pedidos]');
    if (btnVerPedidos) btnVerPedidos.addEventListener('click', function () { irSub('pedidos'); });
    var btnPedidosCrear = estudio.querySelector('[data-mt-pedidos-crear]');
    if (btnPedidosCrear) btnPedidosCrear.addEventListener('click', function () { abrirModalCuenta('Crea tu cuenta'); });

    /* ───────── Sugerencias por estilo ───────── */
    function pintarSugerencias() {
      var est = seleccion('Estilo').valor || '';
      var lbl = estudio.querySelector('[data-mt-sug-estilo]');
      if (lbl) lbl.textContent = est;
      var cont = estudio.querySelector('[data-mt-sugerencias-chips]');
      if (!cont) return;
      var nodo = estudio.querySelector('[data-mt-sugerencias="' + CSS.escape(est) + '"]');
      var items = nodo ? nodo.textContent.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
      var area = estudio.querySelector('[data-mt-detalles]');
      var yaPuestas = area ? area.value.split(',').map(function (t) { return t.trim(); }) : [];
      cont.innerHTML = items.map(function (s) {
        var puesta = yaPuestas.indexOf(s) > -1;
        var esc = s.replace(/"/g, '&quot;');
        return '<button type="button" class="mt-pildora mt-estudio__sug' + (puesta ? ' mt-activa' : '') + '" data-mt-sug="' + esc + '">'
          + '<span>' + s + '</span>'
          + (puesta ? '<i class="mt-estudio__sug-x" data-mt-sug-quitar="' + esc + '" aria-label="Quitar">✕</i>' : '')
          + '</button>';
      }).join('');
      pintarTagsCaja();
    }
    /* Detalles = hasta 5 ETIQUETAS (chips), no texto corrido. El textarea oculto
       sigue siendo el almacén (valor separado por comas) — checkout y cerebro
       lo leen igual que siempre. */
    function leerTags() {
      var area = estudio.querySelector('[data-mt-detalles]');
      return area ? area.value.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
    }
    function pintarTagsCaja() {
      var caja = estudio.querySelector('[data-mt-tags-caja]');
      var campo = estudio.querySelector('[data-mt-tag-campo]');
      if (!caja || !campo) return;
      caja.querySelectorAll('.mt-tags__chip').forEach(function (c) { c.remove(); });
      var tags = leerTags();
      tags.forEach(function (t) {
        var chip = document.createElement('span');
        chip.className = 'mt-tags__chip';
        chip.appendChild(document.createTextNode(t));
        var x = document.createElement('i');
        x.className = 'mt-tags__x';
        x.setAttribute('data-mt-tag-x', t);
        x.setAttribute('aria-label', 'Quitar ' + t);
        x.textContent = '✕';
        chip.appendChild(x);
        caja.insertBefore(chip, campo);
      });
      campo.hidden = tags.length >= 5;
      actualizarConteoDetalles();
    }
    function actualizarConteoDetalles() {
      var conteo = estudio.querySelector('[data-mt-detalles-conteo]');
      if (conteo) {
        var n = leerTags().length;
        conteo.textContent = n + '/5 etiquetas';
        conteo.classList.toggle('mt-oro-texto', n >= 5);
      }
    }
    function quitarEtiqueta(v) {
      var area = estudio.querySelector('[data-mt-detalles]');
      area.value = area.value.split(',').map(function (t) { return t.trim(); })
        .filter(function (t) { return t && t !== v; }).join(', ');
      pintarSugerencias();
    }
    function anadirEtiqueta(v) {
      var area = estudio.querySelector('[data-mt-detalles]');
      var tags = leerTags();
      if (tags.length >= 5 || tags.indexOf(v) > -1) return false;
      tags.push(v);
      area.value = tags.join(', ');
      pintarSugerencias();
      pintarTagsCaja();
      return true;
    }
    estudio.addEventListener('click', function (e) {
      var equis = e.target.closest('[data-mt-sug-quitar]');
      if (equis) {
        e.stopPropagation();
        quitarEtiqueta(equis.getAttribute('data-mt-sug-quitar'));
        return;
      }
      var sug = e.target.closest('[data-mt-sug]');
      if (!sug) return;
      var v = sug.getAttribute('data-mt-sug');
      if (sug.classList.contains('mt-activa')) { quitarEtiqueta(v); } else { anadirEtiqueta(v); }
    });
    var areaDetalles = estudio.querySelector('[data-mt-detalles]');
    if (areaDetalles) areaDetalles.addEventListener('input', actualizarConteoDetalles);

    /* Campo de etiquetas: Enter o coma añade; ✕ quita */
    var campoTag = estudio.querySelector('[data-mt-tag-campo]');
    if (campoTag) {
      function confirmarTag() {
        var v = campoTag.value.replace(/,/g, ' ').trim().slice(0, 24);
        if (!v) return;
        if (anadirEtiqueta(v)) campoTag.value = '';
      }
      campoTag.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); confirmarTag(); }
        if (e.key === 'Backspace' && !campoTag.value) {
          var tags = leerTags();
          if (tags.length) quitarEtiqueta(tags[tags.length - 1]);
          pintarTagsCaja();
        }
      });
      campoTag.addEventListener('blur', confirmarTag);
    }
    estudio.addEventListener('click', function (e) {
      var x = e.target.closest('[data-mt-tag-x]');
      if (x) { quitarEtiqueta(x.getAttribute('data-mt-tag-x')); pintarTagsCaja(); }
      var caja = e.target.closest('[data-mt-tags-caja]');
      if (caja && campoTag && !campoTag.hidden) campoTag.focus();
    });

    /* Ayudas con HOVER en escritorio: los "?" y enlaces de detalle muestran su
       contenido en un panel flotante sin clic (el clic sigue abriendo el modal) */
    var peekAyuda = null;
    var peekAyudaTimer = null;
    function contenidoAyuda(el) {
      var vd = el.getAttribute('data-mt-ver-detalle');
      if (vd) {
        var nodo = estudio.querySelector('[data-mt-detalle="' + CSS.escape(vd) + '"]');
        return nodo ? nodo.innerHTML : '';
      }
      var fi = el.getAttribute('data-mt-foto-info');
      if (fi) {
        var datos = estudio.querySelector('[data-mt-foto-datos="' + CSS.escape(fi) + '"]');
        return datos ? datos.innerHTML : '';
      }
      return '';
    }
    estudio.addEventListener('mouseover', function (e) {
      if (!window.matchMedia || !window.matchMedia('(min-width: 861px)').matches) return;
      var el = e.target.closest('[data-mt-ver-detalle], [data-mt-foto-info]');
      if (!el) return;
      clearTimeout(peekAyudaTimer);
      peekAyudaTimer = setTimeout(function () {
        var html = contenidoAyuda(el);
        if (!html) return;
        if (!peekAyuda) {
          peekAyuda = document.createElement('div');
          peekAyuda.className = 'mt-peek-ayuda';
          document.body.appendChild(peekAyuda);
        }
        peekAyuda.innerHTML = html;
        peekAyuda.hidden = false;
        var r = el.getBoundingClientRect();
        peekAyuda.style.visibility = 'hidden';
        peekAyuda.style.display = 'block';
        var pw = peekAyuda.offsetWidth;
        var ph = peekAyuda.offsetHeight;
        var x2 = Math.min(Math.max(12, r.left + r.width / 2 - pw / 2), window.innerWidth - pw - 12);
        var y2 = r.bottom + 10 + ph > window.innerHeight ? r.top - ph - 10 : r.bottom + 10;
        peekAyuda.style.left = x2 + 'px';
        peekAyuda.style.top = Math.max(10, y2) + 'px';
        peekAyuda.style.visibility = '';
      }, 180);
    });
    estudio.addEventListener('mouseout', function (e) {
      var el = e.target.closest('[data-mt-ver-detalle], [data-mt-foto-info]');
      if (!el) return;
      clearTimeout(peekAyudaTimer);
      if (peekAyuda) peekAyuda.hidden = true;
    });
    document.addEventListener('scroll', function () { if (peekAyuda) peekAyuda.hidden = true; }, { passive: true, capture: true });
    estudio.addEventListener('click', function (e) {
      if (e.target.closest('[data-mt-ver-detalle], [data-mt-foto-info]') && peekAyuda) peekAyuda.hidden = true;
    });

    /* ───────── Galería de la propuesta (4 ángulos) ───────── */
    estudio.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-mt-prop-thumb]');
      if (!thumb) return;
      var main = estudio.querySelector('[data-mt-prop-main]');
      if (!main) return;
      /* INTERCAMBIO: la mini elegida pasa a grande y la grande baja a la mini —
         así con solo 2 minis (frente y perfil) las 3 vistas siempre están a mano */
      var mimg = thumb.querySelector('img');
      var deThumb = thumb.getAttribute('data-mt-prop-src');
      var deMain = main.src;
      main.src = deThumb;
      thumb.setAttribute('data-mt-prop-src', deMain);
      if (mimg) mimg.src = deMain;
      var cap = thumb.querySelector('[data-mt-prop-cap]');
      if (cap) {
        var t = cap.textContent;
        cap.textContent = window.__mtCapPrincipal || 'Ángulo ¾';
        window.__mtCapPrincipal = t;
      }
    });

    /* ───────── Subpantallas y progreso ───────── */
    function subpantalla(paso, nombre) {
      estudio.querySelectorAll('[data-mt-pantalla="' + paso + '"] [data-mt-sub]').forEach(function (s) {
        s.hidden = s.getAttribute('data-mt-sub') !== nombre;
      });
    }

    function progreso(barraSel, estadoSel, mensajes, alTerminar) {
      var barra = estudio.querySelector(barraSel);
      var texto = estudio.querySelector(estadoSel);
      var p = 0;
      if (barra) barra.style.width = '0%';
      var tick = setInterval(function () {
        p += 3.5 + Math.random() * 6;
        if (p >= 100) {
          p = 100;
          clearInterval(tick);
          setTimeout(alTerminar, 350);
        }
        if (barra) barra.style.width = p + '%';
        if (texto) texto.textContent = mensajes[Math.min(Math.floor(p / (100 / mensajes.length)), mensajes.length - 1)];
      }, reduceMotion ? 40 : 150);
    }

    /* ───────── Generación (maqueta o cerebro real) ───────── */
    var MENSAJES_IMG = ['Leyendo tus fotos…', 'Esculpiendo los rasgos…', 'Aplicando tu estilo…', 'Puliendo la propuesta…', 'Lista ✦'];

    /* Config completa del diseño tal como la espera el cerebro (src/prompts.js) */
    function configActual() {
      var sel = {};
      GRUPOS_RES.forEach(function (n) { sel[n] = seleccion(n).valor; });
      var det = estudio.querySelector('[data-mt-detalles]');
      sel.notas = det ? det.value.trim() : '';
      var placaChk = estudio.querySelector('[data-mt-extra="Placa con nombre"]');
      var placaTxt = estudio.querySelector('[data-mt-placa-texto]');
      sel.placa = { activa: !!(placaChk && placaChk.checked), texto: placaTxt ? placaTxt.value.trim() : '' };
      var selColor = seleccion('Color');
      if (selColor.hex) sel.ColorHex = selColor.hex;
      if (selColor.brillo) sel.ColorBrillo = selColor.brillo;
      return sel;
    }

    /* Fotos del cliente comprimidas a ≤1024px JPEG (el worker rechaza payloads mayores) */
    function fotosComprimidas(cb) {
      var slots = Array.prototype.filter.call(slotsFoto, function (s) { return s.classList.contains('mt-cargada'); });
      if (!slots.length) return cb([], []);
      var salida = [];
      var NOMBRES = { 1: 'frente', 2: 'izquierda', 3: 'derecha', 4: 'cuerpo' };
      var nombres = [];
      var pendientes = slots.length;
      slots.forEach(function (slot, i) {
        nombres[i] = NOMBRES[Number(slot.getAttribute('data-mt-foto-n'))] || 'otra';
        var im = new Image();
        im.onload = function () {
          try {
            var esc = Math.min(1, 1024 / Math.max(im.naturalWidth, im.naturalHeight));
            var c = document.createElement('canvas');
            c.width = Math.round(im.naturalWidth * esc);
            c.height = Math.round(im.naturalHeight * esc);
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            var dURL = c.toDataURL('image/jpeg', 0.85);
            if (dURL && dURL.length > 1000) salida[i] = dURL; /* descarta fotos que el canvas no pudo leer (salían de 0 bytes) */
          } catch (e) {}
          if (--pendientes === 0) cb(salida.filter(Boolean), nombres.filter(function (n, k) { return !!salida[k]; }));
        };
        im.onerror = function () { if (--pendientes === 0) cb(salida.filter(Boolean), nombres.filter(function (n, k) { return !!salida[k]; })); };
        im.src = slot.querySelector('img').src;
      });
    }

    /* La propuesta real sustituye a las imágenes de demostración de la ficha.
       El cerebro genera 5 vistas en el color elegido — las minis apuntan a
       /img/ID/{vista}; si alguna vista no llegó, su mini se oculta sola. */
    function aplicarPropuesta(url) {
      estado.urlPropuesta = url;
      var main = estudio.querySelector('[data-mt-prop-main]');
      if (main) main.src = url;
      var minis = estudio.querySelectorAll('[data-mt-prop-thumb]');
      var base = /^(.*\/img\/[^/]+)\/retrato(\?.*)?$/.exec(url || '');
      if (base) {
        /* grande = retrato ¾ · minis = SOLO frente y perfil (intercambiables) */
        var vistasMinis = ['frente', 'derecha'];
        minis.forEach(function (b, i) {
          var u = base[1] + '/' + vistasMinis[i] + (base[2] || '');
          if (!u || i > 1) { b.hidden = true; return; }
          b.hidden = false;
          b.setAttribute('data-mt-prop-src', u);
          var im = b.querySelector('img');
          if (im) {
            /* las vistas laterales pueden aterrizar unos segundos después del
               retrato: un reintento a los 8 s antes de dar la mini por perdida */
            im.onerror = function () {
              im.__reintento = (im.__reintento || 0) + 1;
              if (im.__reintento <= 6) {
                b.hidden = true; /* oculta mientras no llega; reaparece al cargar */
                setTimeout(function () { im.src = u + (u.indexOf('?') === -1 ? '?r=' : '&r=') + im.__reintento; }, 6000);
              }
            };
            im.onload = function () { b.hidden = false; };
            im.src = u;
          }
        });
      }
      /* modo demo (sin cerebro): las minis conservan sus imágenes de muestra */
    }

    /* Volver a empezar desde la ficha: advertencia seria con créditos restantes
       (el diseño actual se pierde y crear otro cuesta 1 crédito) */
    estudio.addEventListener('click', function (e) {
      if (e.target.closest('[data-mt-reiniciar]')) {
        var cred = estado.creditos;
        abrirModal('⚠️ ¿Seguro que quieres volver a empezar?',
          '<div class="mt-adv">' +
          '<p class="mt-modal-estudio__texto">Esta propuesta y tus selecciones <b>se borrarán definitivamente</b>. Generar un personaje nuevo usará <b>1 crédito</b>.</p>' +
          '<p class="mt-adv__cred">Te ' + (cred === 1 ? 'queda <b>1 crédito</b>' : 'quedan <b>' + cred + ' créditos</b>') + ' de diseño.</p>' +
          '<p style="margin-top:16px; display:flex; gap:10px; flex-wrap:wrap;">' +
          '<button type="button" class="mt-btn" data-mt-modal-cerrar-int>Conservar mi diseño</button>' +
          '<button type="button" class="mt-btn mt-btn--peligro" data-mt-reiniciar-si>Borrar y empezar de nuevo</button>' +
          '</p></div>');
        return;
      }
      if (e.target.closest('[data-mt-reiniciar-si]')) {
        LS.del('mtEstudioEstado');
        LS.del('mtEstudioSel');
        window.location.href = window.location.pathname;
      }
      if (e.target.closest('[data-mt-modal-cerrar-int]')) {
        var btnCerrar = estudio.querySelector('[data-mt-modal-cerrar]') || document.querySelector('[data-mt-modal-cerrar]');
        if (btnCerrar) btnCerrar.click();
      }
      var btnEspera = e.target.closest('[data-mt-espera-enviar]');
      if (btnEspera) {
        var cajaE = btnEspera.closest('[data-mt-espera]');
        var campoE = cajaE && cajaE.querySelector('[data-mt-espera-correo]');
        var correoE = campoE ? campoE.value.trim() : '';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(correoE)) {
          if (campoE) campoE.classList.add('mt-campo-error');
          return;
        }
        btnEspera.disabled = true; btnEspera.textContent = 'Guardando…';
        fetch(api('/espera'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ correo: correoE, tema: cajaE.getAttribute('data-mt-espera') })
        }).then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.ok) cajaE.innerHTML = '<p class="mt-espera__texto">✦ ¡Listo! Te avisaremos en cuanto lancemos las figuras de mascotas 🐾</p>';
            else { btnEspera.disabled = false; btnEspera.textContent = 'Avisarme 🐾'; if (campoE) campoE.classList.add('mt-campo-error'); }
          })
          .catch(function () { btnEspera.disabled = false; btnEspera.textContent = 'Avisarme 🐾'; });
        return;
      }
      if (e.target.closest('[data-mt-generar-forzar]')) {
        var btnCerrar2 = estudio.querySelector('[data-mt-modal-cerrar]') || document.querySelector('[data-mt-modal-cerrar]');
        if (btnCerrar2) btnCerrar2.click();
        window.__mtSaltarValidacion = true;
        generarPropuesta();
      }
    });

    /* ── Sala de espera (r48) ── */
    var ESTILOS_SALA = [
      ['Realista', 'realista'], ['Película animada', 'animado-tipo-pelicula'], ['Art toy', 'art-toy'],
      ['Anime', 'anime'], ['Chibi', 'chibi'], ['Low poly', 'low-poly'],
      ['Origami', 'origami'], ['Cabezón', 'cabezon'], ['Cúbico', 'cubico']
    ];
    function prepararSala() {
      var cont = estudio.querySelector('[data-mt-sala-estilos]');
      var fig = estudio.querySelector('[data-mt-sala-figura]');
      var nom = estudio.querySelector('[data-mt-sala-nombre]');
      var base = estudio.getAttribute('data-mt-acabados-base') || '';
      if (!cont || !fig || !base) return;
      var idx = 0;
      function mostrar(i) {
        idx = (i + ESTILOS_SALA.length) % ESTILOS_SALA.length;
        fig.src = base + 'mt-canon-' + ESTILOS_SALA[idx][1] + '.webp';
        if (nom) nom.textContent = ESTILOS_SALA[idx][0];
        cont.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('mt-activa', k === idx); });
      }
      if (!cont.childElementCount) {
        ESTILOS_SALA.forEach(function (e, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'mt-pildora'; b.textContent = e[0];
          b.addEventListener('click', function () { mostrar(i); clearInterval(cont.__giro); });
          cont.appendChild(b);
        });
        /* rotación suave automática cada 5 s hasta que el cliente toque */
        cont.__giro = setInterval(function () { mostrar(idx + 1); }, 5000);
      }
      var actual = seleccion('Estilo').valor;
      var i0 = ESTILOS_SALA.findIndex(function (e) { return e[0] === actual; });
      mostrar(i0 > -1 ? i0 : 0);
      /* correo: precargar el de la cuenta */
      var inp = estudio.querySelector('[data-mt-correo]');
      if (inp && cuenta && cuenta.correo && !inp.value) inp.value = cuenta.correo;
    }
    /* Aviso por correo (ruta /avisar del cerebro) */
    estudio.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mt-correo-enviar]')) return;
      var inp = estudio.querySelector('[data-mt-correo]');
      var correo = (inp && inp.value || '').trim();
      if (!correo || correo.indexOf('@') < 1) { if (inp) inp.classList.add('mt-campo-error'); return; }
      if (inp) inp.classList.remove('mt-campo-error');
      var manda = function () {
        fetch(api('/avisar'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: estado.idDiseno, correo: correo }) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok) {
              var caja = estudio.querySelector('[data-mt-correo-caja]');
              var okEl = estudio.querySelector('[data-mt-correo-ok]');
              var dest = estudio.querySelector('[data-mt-correo-dest]');
              if (dest) dest.textContent = correo;
              if (okEl) okEl.hidden = false;
              caja.querySelector('.mt-espera__correo-fila').hidden = true;
              caja.querySelector('label').hidden = true;
            }
          }).catch(function () {});
      };
      if (estado.idDiseno) manda(); else setTimeout(manda, 3000); /* /generar aún respondiendo */
    });
    function pintarEtapa(clave) {
      var orden = ['retrato', 'juez', 'perfiles'];
      var i = orden.indexOf(clave);
      estudio.querySelectorAll('[data-mt-espera-etapas] li').forEach(function (li) {
        var j = orden.indexOf(li.getAttribute('data-mt-etapa'));
        li.classList.toggle('mt-hecha', j < i);
        li.classList.toggle('mt-actual', j === i);
      });
    }
    /* Notificación LOCAL al terminar (sin servidor; en iOS solo como app instalada) */
    var avisarBtn = estudio.querySelector('[data-mt-avisar]');
    if (avisarBtn && 'Notification' in window) {
      if (Notification.permission === 'default') avisarBtn.hidden = false;
      avisarBtn.addEventListener('click', function () {
        Notification.requestPermission().then(function (p) {
          avisarBtn.hidden = true;
          if (p === 'granted') window.__mtAvisar = true;
        });
      });
    }
    function notificarLista() {
      try {
        if ('Notification' in window && Notification.permission === 'granted' && document.visibilityState !== 'visible') {
          new Notification('Tu personaje está listo ✦', { body: 'Vuelve al Estudio tresde para verlo y confirmar tu pedido.', icon: '/cdn/shop/t/3/assets/mt-favicon.png' });
        }
      } catch (e) {}
    }

    /* Generación REAL contra el cerebro: POST /generar → sondeo /estado/:id */
    function generarReal() {
      irSub('generando');
      prepararSala();
      pintarEtapa('retrato');
      var barra = estudio.querySelector('[data-mt-barra2]');
      var texto = estudio.querySelector('[data-mt-estado2]');
      var pct = 4;
      var vivo = true;
      var anim = setInterval(function () {
        pct = Math.min(pct + (pct < 60 ? 2.4 : 0.4), 92);
        if (barra) barra.style.width = pct + '%';
        if (texto) texto.textContent = MENSAJES_IMG[Math.min(Math.floor(pct / 25), MENSAJES_IMG.length - 2)];
      }, 400);
      function fallo(msg) {
        if (!vivo) return;
        vivo = false;
        clearInterval(anim);
        if (window.__mtRelojNota) clearInterval(window.__mtRelojNota);
        var notaF = estudio.querySelector('[data-mt-espera-nota]'); if (notaF) notaF.hidden = true;
        estado.creditos += 1; /* devolución visual; el cerebro es la fuente de verdad */
        guardarCreditos();
        pintar();
        irSub('detalles');
        abrirModal('No pudimos generar tu propuesta', '<p class="mt-modal-estudio__texto">' + (msg || 'Inténtalo de nuevo en un momento.') + '</p>');
      }
      var slotsFotos = [];
      function disparar(fotos) {
        fetch(api('/generar'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ config: configActual(), fotos: fotos, slots: slotsFotos })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) return fallo(res.j && res.j.error);
            LS.set('mtHaGenerado', 1); /* desde aquí los créditos del cerebro mandan */
            if (res.j.id) { estado.idDiseno = res.j.id; estado.pasoDirecto = res.j.paso_directo || ''; guardarEstadoCompleto(); }
            var inicio = Date.now();
            var fallosRetrato = 0;
            function notaEspera() {
              var seg = Math.round((Date.now() - inicio) / 1000);
              var nota = estudio.querySelector('[data-mt-espera-nota]');
              if (!nota) return;
              if (seg > 100) nota.textContent = 'El taller va lento hoy (' + seg + ' s). Tu personaje se termina solo en segundo plano: puedes cerrar esta pestaña y verlo en Mi Estudio en unos minutos.';
              else if (seg > 40) nota.textContent = 'Está tardando un poco más de lo normal (' + seg + ' s) — suele tomar de 1 a 2 minutos. Puedes esperar aquí o cerrar: lo guardamos en Mi Estudio.';
              else nota.textContent = 'Suele tardar entre 30 s y 2 min. No hace falta que te quedes: lo guardamos en Mi Estudio.';
              nota.hidden = false;
            }
            var relojNota = setInterval(notaEspera, 1000); window.__mtRelojNota = relojNota;
            notaEspera();
            function propuestaLista(d) {
              /* Píxel Meta: conversión de generación (solo cerebro real) */
              try { if (typeof fbq === 'function') fbq('trackCustom', 'GeneracionFigura3D', { fuente: 'estudio' }); } catch (err) {}
              notificarLista();
              pintarEtapa('fin');
              vivo = false;
              clearInterval(anim);
              clearInterval(relojNota);
              if (barra) barra.style.width = '100%';
              if (texto) texto.textContent = MENSAJES_IMG[MENSAJES_IMG.length - 1];
              aplicarPropuesta(urlConInvitado(d.url_imagen));
              estado.propuestaLista = true;
              marcarDiseno();
              estado.sub1 = 'detalles';
              guardarEstadoCompleto();
              sincronizarCreditos();
              setTimeout(function () { ir(2); }, 600);
            }
            /* Las vistas laterales y el clay se piden en segundo plano tras el retrato */
            function continuarFondo(n) {
              if (n > 12) return;
              fetch(estado.pasoDirecto || api('/paso/' + estado.idDiseno), { method: 'POST', mode: 'cors' })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                  if (d && d.pendiente) setTimeout(function () { continuarFondo(n + 1); }, d.en_curso ? 6000 : 300);
                })
                .catch(function () { setTimeout(function () { continuarFondo(n + 1); }, 6000); });
            }
            /* Generación POR PASOS: cada llamada hace una pieza de forma síncrona */
            (function paso() {
              if (!vivo) return;
              if (Date.now() - inicio > 6 * 60 * 1000) {
                /* antes de rendirnos: ¿ya terminó? (caso real móvil: la pestaña se congeló y la figura ya estaba en Mi Estudio) */
                fetch(api('/estado/' + estado.idDiseno)).then(function (r) { return r.json(); })
                  .then(function (e2) {
                    if (e2.estado === 'imagen_lista' && e2.url_imagen) { propuestaLista(e2); return; }
                    vivo = false; clearInterval(anim); clearInterval(relojNota);
                    irSub('detalles');
                    abrirModal('Tu diseño sigue en proceso', '<p class="mt-modal-estudio__texto">Hoy el taller va más lento de lo normal, pero tu personaje se sigue generando en segundo plano. <b>Puedes quedarte: esta pantalla avanzará sola en cuanto esté.</b> También lo encontrarás en <b>Mi Estudio</b>.</p>');
                    sincronizarCreditos();
                    var reloj2 = setInterval(function () {
                      fetch(api('/estado/' + estado.idDiseno)).then(function (r) { return r.json(); })
                        .then(function (e3) {
                          if (e3.estado === 'imagen_lista' && e3.url_imagen) {
                            clearInterval(reloj2);
                            cerrarModales();
                            vivo = true;
                            propuestaLista(e3);
                          }
                        }).catch(function () {});
                    }, 10000);
                  }).catch(function () { setTimeout(paso, 5000); });
                return;
              }
              fetch(estado.pasoDirecto || api('/paso/' + estado.idDiseno), { method: 'POST', mode: 'cors' })
                .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
                .then(function (res) {
                  var d = res.j || {};
                  if (texto) {
                    if (d.pieza === 'retrato') { texto.textContent = 'Revisando la escultura…'; pintarEtapa('juez'); }
                    else if (d.pieza === 'retrato-juez' && d.pendiente === 'retrato') { texto.textContent = 'Corrigiendo detalles…'; pintarEtapa('retrato'); }
                    else if (d.pieza === 'retrato-juez') { texto.textContent = 'Afinando los perfiles…'; pintarEtapa('perfiles'); }
                  }
                  if (d.estado === 'imagen_lista' && d.url_imagen) {
                    propuestaLista(d);
                    if (d.pendiente) continuarFondo(0);
                    return;
                  }
                  if (d.estado === 'imagen_error') { fallo('El taller tuvo un problema con esta generación — tu crédito fue devuelto.'); return; }
                  if (!res.ok && d.error === 'fallo') {
                    if (++fallosRetrato >= 4) { fallo('El taller no pudo esculpir tu retrato esta vez — inténtalo de nuevo en un momento.'); return; }
                    setTimeout(paso, 1500);
                    return;
                  }
                  if (d.en_curso) {
                    /* otra pestaña/el cron lo está haciendo: esperar y releer el estado */
                    setTimeout(function () {
                      fetch(api('/estado/' + estado.idDiseno)).then(function (r) { return r.json(); })
                        .then(function (e) { if (e.estado === 'imagen_lista' && e.url_imagen) propuestaLista(e); else paso(); })
                        .catch(paso);
                    }, 5000);
                    return;
                  }
                  setTimeout(paso, 300);
                })
                .catch(function () { setTimeout(paso, 4000); });
            })();
          })
          .catch(function () { fallo('Sin conexión con el taller — revisa tu internet e inténtalo de nuevo.'); });
      }

      fotosComprimidas(function (fotos, nombres) {
        slotsFotos = nombres || [];
        /* Tomas 3/4 SILENCIOSAS del escáner (2026-09-26): viajan como fotos 5-6;
           el cerebro acepta 6 y las usa como referencia extra de parecido */
        if (Array.isArray(window.__mtEscaneoExtra)) {
          window.__mtEscaneoExtra.forEach(function (ex) {
            if (fotos.length < 6 && ex && ex.uri) { fotos.push(ex.uri); slotsFotos.push(ex.slot); }
          });
        }
        /* Caso TRSD-0033 (2026-09-06): la compresión puede fallar en silencio (HEIC/
           formato raro) y mandar 0 fotos → el cerebro esculpiría un personaje genérico.
           Sin al menos 1 foto real, NO se genera (el cerebro también lo rechaza en 422). */
        if (!fotos || !fotos.length) {
          fallo('No pudimos leer tus fotos en este navegador — vuelve a subirlas (JPG o PNG funcionan mejor).');
          irSub('fotos');
          return;
        }
        /* Validación IA previa (gratis): duplicadas / personas distintas / fotos
           inservibles — evita gastar el crédito en un mal resultado */
        if (window.__mtSaltarValidacion) {
          window.__mtSaltarValidacion = false;
          disparar(fotos);
          return;
        }
        fetch(api('/validar'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fotos: fotos })
        })
          .then(function (r) { return r.json(); })
          .catch(function () { return { ok: true, advertencias: [] }; })
          .then(function (v) {
            /* BLOQUEO duro (solo personas, 2026-09-13): mascotas/autos/objetos no
               generan — sin "continuar de todos modos" y sin gastar el crédito */
            if (v && v.bloqueos && v.bloqueos.length && vivo) {
              vivo = false;
              clearInterval(anim);
              estado.creditos += 1; /* aún no se gastó nada en el cerebro */
              guardarCreditos();
              pintar();
              irSub('fotos');
              var cajaEspera = v.espera === 'mascotas'
                ? '<div class="mt-espera" data-mt-espera="mascotas">' +
                  '<p class="mt-espera__texto">¿Quieres que te avisemos cuando lancemos las <b>figuras de mascotas</b>?</p>' +
                  '<div class="mt-espera__fila"><input type="email" data-mt-espera-correo placeholder="tu@correo.com" autocomplete="email">' +
                  '<button type="button" class="mt-btn mt-btn--fantasma" data-mt-espera-enviar>Avisarme 🐾</button></div>' +
                  '</div>'
                : '';
              abrirModal('El Estudio esculpe personas ✦',
                '<div class="mt-adv"><ul class="mt-adv__lista">' +
                v.bloqueos.map(function (b) { return '<li>' + b + '</li>'; }).join('') +
                '</ul>' + cajaEspera + '<p style="margin-top:16px;">' +
                '<button type="button" class="mt-btn mt-btn--oro" data-mt-modal-cerrar-int>Cambiar mis fotos</button>' +
                '</p></div>');
              return;
            }
            if (v && v.advertencias && v.advertencias.length && vivo) {
              vivo = false;
              clearInterval(anim);
              estado.creditos += 1; /* aún no se gastó nada en el cerebro */
              guardarCreditos();
              pintar();
              irSub('fotos');
              abrirModal('Revisa tus fotos antes de continuar',
                '<div class="mt-adv"><ul class="mt-adv__lista">' +
                v.advertencias.map(function (a) { return '<li>' + a + '</li>'; }).join('') +
                '</ul><p style="margin-top:16px; display:flex; gap:10px; flex-wrap:wrap;">' +
                '<button type="button" class="mt-btn mt-btn--oro" data-mt-modal-cerrar-int>Revisar mis fotos</button>' +
                '<button type="button" class="mt-btn" data-mt-generar-forzar>Continuar de todos modos</button>' +
                '</p></div>');
              return;
            }
            if (vivo) disparar(fotos);
          });
      });
    }

    function marcarDiseno() {
      if (!estado.idDiseno) {
        estado.idDiseno = 'TRSD-' + Math.random().toString(36).slice(2, 6).toUpperCase();
      }
      estudio.querySelectorAll('[data-mt-id-diseno]').forEach(function (el) {
        el.textContent = estado.idDiseno;
        el.hidden = false;
      });
      var thumb = estudio.querySelector('[data-mt-thumb-img]');
      var color = estudio.querySelector('[data-mt-thumb-color]');
      if (thumb) {
        thumb.src = estado.urlPropuesta || estudio.getAttribute('data-mt-propuesta-img');
        thumb.hidden = false;
        if (color) color.hidden = true;
        var ac = estudio.querySelector('[data-mt-thumb-acabado]'); if (ac) ac.hidden = true;
      }
    }

    function generarPropuesta() {
      if (estado.creditos < 1) {
        if (!cuenta) { abrirModalCuenta(CEREBRO ? 'Tus 3 diseños gratis se agotaron — crea tu cuenta y recibe 3 más' : 'Tus créditos de prueba se agotaron'); }
        else { abrirModal('Créditos agotados', '<p class="mt-modal-estudio__texto">Muy pronto podrás conseguir packs de créditos de diseño en la tienda. Escríbenos si quieres seguir creando hoy mismo.</p>'); }
        return;
      }
      estado.creditos -= 1;
      guardarCreditos();
      if (CEREBRO) { generarReal(); return; }
      irSub('generando');
      progreso('[data-mt-barra2]', '[data-mt-estado2]', MENSAJES_IMG, function () {
        estado.propuestaLista = true;
        marcarDiseno();
        estado.sub1 = 'detalles';   /* al volver atrás se aterriza en Detalles */
        ir(2);                       /* la propuesta ahora vive en "Confirma tu pedido" */
      });
    }

    /* "Probar otro estilo con las mismas fotos" (petición Octavio 2026-09-06):
       las fotos siguen cargadas en los inputs — solo se limpia el estilo y se
       aterriza en el sub 'base' para elegir otro. El diseño anterior queda en Mi Estudio. */
    var btnOtroEstilo = estudio.querySelector('[data-mt-otro-estilo]');
    if (btnOtroEstilo) {
      btnOtroEstilo.addEventListener('click', function () {
        var g = estudio.querySelector('[data-mt-grupo="Estilo"]');
        if (g) g.querySelectorAll('.mt-activa').forEach(function (b) { b.classList.remove('mt-activa'); });
        estado.propuestaLista = false;
        estado.idDiseno = null; estado.urlPropuesta = null; estado.pasoDirecto = '';
        estado.sub1 = fotosCargadas() >= 1 ? 'base' : 'fotos';
        guardarSelecciones();
        guardarEstadoCompleto();
        ir(1);
      });
    }

    /* Opinión del cliente sobre su figura (se guarda en el cerebro y se ve en /admin/taller) */
    var cajaOpinar = estudio.querySelector('[data-mt-opinar-caja]');
    if (cajaOpinar) {
      var estrellasSel = 0;
      cajaOpinar.querySelectorAll('[data-mt-estrella]').forEach(function (b) {
        b.addEventListener('click', function () {
          estrellasSel = Number(b.getAttribute('data-mt-estrella'));
          cajaOpinar.querySelectorAll('[data-mt-estrella]').forEach(function (x) {
            x.classList.toggle('mt-activa', Number(x.getAttribute('data-mt-estrella')) <= estrellasSel);
          });
        });
      });
      var btnOpinar = cajaOpinar.querySelector('[data-mt-opinar]');
      if (btnOpinar) {
        btnOpinar.addEventListener('click', function () {
          var campo = cajaOpinar.querySelector('[data-mt-opinar-texto]');
          var txt = campo ? campo.value.trim() : '';
          if (!estado.idDiseno || (!txt && !estrellasSel)) return;
          btnOpinar.disabled = true; btnOpinar.textContent = 'Enviando…';
          fetch(api('/opinar'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: estado.idDiseno, texto: txt, estrellas: estrellasSel })
          }).then(function (r) { return r.json(); })
            .then(function () { cajaOpinar.innerHTML = '<p class="mt-ficha__opinar-gracias">✦ ¡Gracias! Tu opinión nos ayuda a mejorar cada figura.</p>'; })
            .catch(function () { btnOpinar.disabled = false; btnOpinar.textContent = 'Enviar mi opinión'; });
        });
      }
    }

    /* Elección móvil de método de fotos (2026-09-27): la tarjeta quita el modo
       "eligiendo" y muestra la cuadrícula; la de escanear la engancha mt-escaner.js */
    var btnElegirCarga = estudio.querySelector('[data-mt-elegir-carga]');
    if (btnElegirCarga) {
      btnElegirCarga.addEventListener('click', function () {
        var sub = estudio.querySelector('[data-mt-sub="fotos"]');
        if (sub) sub.classList.remove('mt-fotos-eligiendo');
      });
    }

    var btnGenerar = estudio.querySelector('[data-mt-generar]');
    if (btnGenerar) {
      btnGenerar.addEventListener('click', function () {
        if (faltantes().length || fotosCargadas() < 1) return;
        var placaChk = estudio.querySelector('[data-mt-extra="Placa con nombre"]');
        var placaTxt = estudio.querySelector('[data-mt-placa-texto]');
        if (placaChk && placaChk.checked && placaTxt && !placaTxt.value.trim()) {
          abrirModal('¿Qué grabamos en la placa?', '<p class="mt-modal-estudio__texto">Marcaste <b>Placa con nombre</b> pero no escribiste el texto. Escríbelo (máx. 24 caracteres) o desmarca la placa para continuar.</p>');
          placaTxt.classList.add('mt-campo-error');
          setTimeout(function () { try { placaTxt.focus(); } catch (e) {} }, 50);
          return;
        }
        generarPropuesta();
      });
    }
    var btnRegen = estudio.querySelector('[data-mt-regenerar]');
    if (btnRegen) {
      btnRegen.addEventListener('click', function () {
        if (estado.creditos < 1) { generarPropuesta(); return; } /* solo muestra el aviso */
        estado.propuestaLista = false;
        generarPropuesta();
      });
    }
    var btnAprobar = estudio.querySelector('[data-mt-aprobar2]');
    if (btnAprobar) btnAprobar.addEventListener('click', function () { ir(2); });

    /* ───────── Pago: checkout REAL de Shopify + retorno ─────────
       El pago lo confirma SOLO el cerebro (webhook orders/paid). El "pago
       simulado" y el botón "Ya pagué" de la maqueta se retiraron (2026-08-30):
       ya no hay forma de avanzar sin que Shopify confirme el cobro. */

    function confirmarPago() {
      estado.pagado = true;
      subpantalla(2, 'exito');
      pintar();
      guardarEstadoCompleto();
      setTimeout(function () { ir(4); }, reduceMotion ? 200 : 1500);
    }

    var btnPagar = estudio.querySelector('[data-mt-pagar]');
    if (btnPagar) {
      btnPagar.addEventListener('click', function () {
        var tam = seleccion('Tamaño').valor;
        if (mapaVariantes && tam && mapaVariantes[tam]) {
          guardarEstadoCompleto();
          var enc = encodeURIComponent;
          var partes = [
            'attributes[Diseño]=' + enc(estado.idDiseno || 'TRSD'),
            'attributes[Tipo]=' + enc(seleccion('Tipo').valor || ''),
            'attributes[Estilo]=' + enc(seleccion('Estilo').valor || ''),
            'attributes[Tamaño]=' + enc(tam),
            'attributes[Color]=' + enc(seleccion('Color').valor || ''),
            'attributes[Pose]=' + enc(seleccion('Pose').valor || ''),
            'attributes[Base]=' + enc(seleccion('Base').valor || 'Circular clásica')
          ];
          var extras = extrasElegidos();
          if (extras.length) {
            partes.push('attributes[Extras]=' + enc(extras.map(function (x) { return x.nombre + ' (+$' + x.precio + ')'; }).join(' · ')));
            var placa = estudio.querySelector('[data-mt-placa-texto]');
            if (placa && placa.value.trim()) partes.push('attributes[Texto de la placa]=' + enc(placa.value.trim()));
          }
          /* La placa viaja como segunda línea del carrito para que el checkout
             cobre lo mismo que muestra el Estudio. Cualquier otro extra futuro
             sin variante propia seguiría registrado solo como atributo. */
          var lineas = mapaVariantes[tam] + ':1';
          var llevaPlaca = extras.some(function (x) { return x.nombre === 'Placa con nombre'; });
          if (llevaPlaca && variantePlaca) { lineas += ',' + variantePlaca + ':1'; }
          var llevaPintado = extras.some(function (x) { return x.nombre === 'Pintado a mano'; });
          if (llevaPintado && variantesPintado[tam]) { lineas += ',' + variantesPintado[tam].id + ':1'; }
          var det = (estudio.querySelector('[data-mt-detalles]').value || '').trim().slice(0, 140);
          if (det) partes.push('note=' + enc('Detalles del diseño: ' + det));
          urlCheckout = '/cart/' + lineas + '?' + partes.join('&');
          window.open(urlCheckout, '_blank', 'noopener'); /* el webhook orders/paid confirma solo */
          subpantalla(2, 'esperando');
          pintar();
          vigilarPago();
        } else {
          /* Sin mapa de variantes no hay checkout que abrir: se avisa, nunca se simula el pago */
          abrirModal('No pudimos abrir el checkout', '<p class="mt-modal-estudio__texto">No encontramos el producto de tu tamaño. Recarga la página e inténtalo de nuevo; si sigue pasando, escríbenos a <b>contact@tresde.io</b> con tu ID de diseño.</p>');
        }
      });
    }
    var vigilante = null;
    function consultarPago(alResultado) {
      if (!CEREBRO || !estado.idDiseno) { if (alResultado) alResultado(false); return; }
      fetch(api('/estado/' + estado.idDiseno))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ok = !!(d && d.pagado);
          if (ok && !estado.pagado) {
            estado.pedido = d.pedido || null;
            confirmarPago();
          }
          if (alResultado) alResultado(ok, d);
        })
        .catch(function () { if (alResultado) alResultado(false); });
    }
    function vigilarPago() {
      if (vigilante) return;
      vigilante = setInterval(function () {
        if (estado.pagado || estado.paso !== 2) { clearInterval(vigilante); vigilante = null; return; }
        consultarPago();
      }, 6000);
      consultarPago();
    }
    var btnPagoReabrir = estudio.querySelector('[data-mt-pago-reabrir]');
    if (btnPagoReabrir) {
      btnPagoReabrir.addEventListener('click', function () {
        window.open(urlCheckout || '/products/personaje-personalizado-estudio', '_blank', 'noopener');
      });
    }
    var btnPagoVolver = estudio.querySelector('[data-mt-pago-volver]');
    if (btnPagoVolver) {
      btnPagoVolver.addEventListener('click', function () { subpantalla(2, 'revisar'); pintar(); });
    }

    /* El visor 3D (model-viewer + GLB) se retiró junto con el paso "En 3D";
       volverá cuando la conversión a 3D esté lista de verdad. */

    /* ───────── Memoria ───────── */
    function guardarSelecciones() {
      var sel = {};
      GRUPOS_RES.forEach(function (n) { sel[n] = seleccion(n).valor; });
      LS.set('mtEstudioSel', sel);
    }
    function restaurarSelecciones() {
      var sel = LS.get('mtEstudioSel', null);
      if (!sel) return;
      Object.keys(sel).forEach(function (n) {
        if (!sel[n]) return;
        var grupo = estudio.querySelector('[data-mt-grupo="' + n + '"]');
        if (!grupo) return;
        var pil = grupo.querySelector('[data-mt-eleccion="' + CSS.escape(sel[n]) + '"]');
        if (!pil || pil.classList.contains('mt-activa') || pil.hasAttribute('data-mt-agotado')) return;
        grupo.querySelectorAll('[data-mt-eleccion]').forEach(function (p) { p.classList.remove('mt-activa'); });
        pil.classList.add('mt-activa');
      });
    }
    function guardarEstadoCompleto() {
      guardarSelecciones();
      var placaChkG = estudio.querySelector('[data-mt-extra="Placa con nombre"]');
      var placaTxtG = estudio.querySelector('[data-mt-placa-texto]');
      var detG = estudio.querySelector('[data-mt-detalles]');
      LS.set('mtEstudioEstado', {
        placa: { activa: !!(placaChkG && placaChkG.checked), texto: placaTxtG ? placaTxtG.value : '' },
        notas: detG ? detG.value : '',
        paso: estado.paso,
        sub1: estado.sub1,
        maxPaso: estado.maxPaso,
        propuestaLista: estado.propuestaLista,
        pagado: estado.pagado,
        idDiseno: estado.idDiseno,
        urlPropuesta: estado.urlPropuesta
      });
    }
    /* Extras y notas se restauran desde el estado guardado — y, si hay cerebro,
       desde la configuración real del diseño (fuente de verdad para el cobro) */
    function restaurarExtras(placa, notas) {
      var placaChk = estudio.querySelector('[data-mt-extra="Placa con nombre"]');
      var placaTxt = estudio.querySelector('[data-mt-placa-texto]');
      var det = estudio.querySelector('[data-mt-detalles]');
      if (placa && placaChk) {
        placaChk.checked = !!placa.activa;
        if (placaTxt) { placaTxt.value = placa.texto || ''; placaTxt.hidden = !placa.activa; }
        placaChk.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof notas === 'string' && det && !det.value) det.value = notas;
      ajustarPlacaSegunBase(); /* si la base restaurada es "Sin base", la placa no aplica */
      actualizarResumen();
      pintarExtrasFicha();
    }
    function restaurarEstadoCompleto() {
      var g = LS.get('mtEstudioEstado', null);
      if (!g) return false;
      estado.maxPaso = g.maxPaso || 1;
      estado.sub1 = g.sub1 || 'fotos';
      if (estado.sub1 === 'generando' || estado.sub1 === 'propuesta') estado.sub1 = 'detalles';
      estado.propuestaLista = !!g.propuestaLista;
      estado.pagado = !!g.pagado && !CEREBRO; /* con cerebro, el pago se re-verifica en el servidor */
      estado.idDiseno = g.idDiseno || null;
      if (CEREBRO && g.pagado && g.idDiseno) {
        consultarPago(function (ok) { if (ok) { estado.pagado = true; if ((g.paso || 1) >= 3) ir(4); } });
      }
      restaurarExtras(g.placa, g.notas);
      if (g.urlPropuesta) aplicarPropuesta(g.urlPropuesta);
      if (estado.propuestaLista) marcarDiseno();
      ir(Math.min(g.paso || 1, MAX));
      return true;
    }

    /* ───────── Cuenta (demo) ───────── */
    var modalCuenta = estudio.querySelector('[data-mt-modal-cuenta]');
    function pintarCuenta() {
      var b = estudio.querySelector('[data-mt-cuenta]');
      if (!b) return;
      b.textContent = cuenta ? '◉ ' + (cuenta.nombre || '').split(' ')[0] : 'Crear cuenta';
      b.classList.toggle('mt-ok', !!cuenta);
    }
    function abrirModalCuenta(titulo) {
      if (!modalCuenta) return;
      modalCuenta.querySelector('[data-mt-cuenta-titulo]').textContent = titulo || (cuenta ? 'Tu cuenta' : 'Crea tu cuenta');
      modalCuenta.querySelector('[data-mt-cuenta-form]').hidden = !!cuenta;
      modalCuenta.querySelector('[data-mt-cuenta-sesion]').hidden = !cuenta;
      if (cuenta) {
        modalCuenta.querySelector('[data-mt-cuenta-datos]').textContent = cuenta.nombre + ' · ' + cuenta.correo + ' · ' + estado.creditos + ' créditos';
      }
      modalCuenta.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    var btnCuenta = estudio.querySelector('[data-mt-cuenta]');
    if (btnCuenta) btnCuenta.addEventListener('click', function () { abrirModalCuenta(); });

    /* ───────── Modales genéricos ───────── */
    var modal = estudio.querySelector('[data-mt-modal-estudio]');
    var modalSalir = estudio.querySelector('[data-mt-modal-salir]');

    function infoNodo(grupo, valor) {
      return estudio.querySelector('[data-mt-info][data-mt-info-grupo="' + grupo + '"][data-mt-info-valor="' + CSS.escape(valor) + '"]');
    }
    function tarjetaInfoHTML(nodo, conBoton) {
      if (!nodo) return '';
      var valor = nodo.getAttribute('data-mt-info-valor');
      var img = nodo.getAttribute('data-mt-info-img');
      var etq = nodo.getAttribute('data-mt-info-etiqueta');
      /* sin imagen no se muestra placeholder: solo texto */
      var visual = img ? '<div class="mt-modal-estudio__visual"><img src="' + img + '" alt="' + valor + '" loading="lazy"></div>' : '';
      return '<article class="mt-modal-estudio__opcion"' + (conBoton ? ' data-mt-modal-elegir="' + valor + '" tabindex="0" role="button"' : '') + '>'
        + visual
        + '<h5>' + valor + (etq ? ' <em class="mt-etq mt-etq--oro">' + etq + '</em>' : '') + '</h5>'
        + '<p>' + nodo.textContent.trim() + '</p>'
        + (conBoton ? '<span class="mt-modal-estudio__elegir">Elegir esta</span>' : '')
        + '</article>';
    }
    function abrirModal(titulo, html) {
      if (!modal) return;
      modal.querySelector('[data-mt-modal-titulo]').textContent = titulo;
      modal.querySelector('[data-mt-modal-cuerpo]').innerHTML = html;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function cerrarModales() {
      [modal, modalCuenta, modalSalir, modalFotos].forEach(function (m) { if (m) m.hidden = true; });
      document.documentElement.style.overflow = '';
    }

    estudio.addEventListener('click', function (e) {
      var cual = e.target.closest('[data-mt-cual]');
      if (cual) {
        var grupo = cual.getAttribute('data-mt-cual');
        if (grupo === 'Tamaño') {
          var nodoT = estudio.querySelector('[data-mt-info-tamanos]');
          var imgT = nodoT ? nodoT.getAttribute('data-mt-info-img') : null;
          var html = '<div class="mt-modal-estudio__tamanos">';
          html += imgT
            ? '<img class="mt-modal-estudio__tamanos-img" src="' + imgT + '" alt="Comparativa de tamaños">'
            : '<div class="mt-modal-estudio__visual" style="aspect-ratio: 21/9;"><span class="mt-modal-estudio__sin-img">✦</span></div>';
          if (nodoT && nodoT.textContent.trim()) html += '<p class="mt-modal-estudio__texto">' + nodoT.textContent.trim() + '</p>';
          html += '<div class="mt-modal-estudio__tallas">';
          estudio.querySelectorAll('[data-mt-grupo="Tamaño"] .mt-pildora').forEach(function (p) {
            var v = p.getAttribute('data-mt-eleccion');
            var pr = p.getAttribute('data-mt-precio');
            html += '<button type="button" class="mt-pildora" data-mt-modal-talla="' + v + '">' + v + ' · $' + String(pr).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</button>';
          });
          html += '</div></div>';
          abrirModal('Elige tu tamaño', html);
          return;
        }
        var nodos = estudio.querySelectorAll('[data-mt-info][data-mt-info-grupo="' + grupo + '"]');
        var listaHtml = '<div class="mt-modal-estudio__rejilla' + (grupo === 'Motor' ? ' mt-modal-estudio__rejilla--dos' : '') + '">';
        nodos.forEach(function (n) { if (n.getAttribute('data-mt-info-valor') !== 'Multicolor') listaHtml += tarjetaInfoHTML(n, true); });
        var titulos = { Tipo: 'Elige tu tipo de pieza', Estilo: 'Elige tu estilo', Motor: 'Elige tu motor de modelado 3D' };
        abrirModal(titulos[grupo] || grupo, listaHtml + '</div>');
        modal.setAttribute('data-mt-modal-grupo', grupo);
        return;
      }
      var fotoInfo = e.target.closest('[data-mt-foto-info]');
      if (fotoInfo) {
        e.preventDefault();
        e.stopPropagation();
        var nf = fotoInfo.getAttribute('data-mt-foto-info');
        var datos = estudio.querySelector('[data-mt-foto-datos="' + nf + '"]');
        if (datos) {
          abrirModal('Foto ' + nf + ' · ' + datos.getAttribute('data-mt-info-valor'), '<div class="mt-modal-estudio__rejilla mt-modal-estudio__rejilla--una">' + tarjetaInfoHTML(datos, false) + '</div>');
        }
        return;
      }
      if (e.target.closest('[data-mt-modal-cerrar]')) { cerrarModales(); return; }
      var talla = e.target.closest('[data-mt-modal-talla]');
      if (talla) {
        var pilT = estudio.querySelector('[data-mt-grupo="Tamaño"] [data-mt-eleccion="' + CSS.escape(talla.getAttribute('data-mt-modal-talla')) + '"]');
        if (pilT) pilT.click();
        cerrarModales();
        return;
      }
      var elegir = e.target.closest('[data-mt-modal-elegir]');
      if (elegir) {
        var g2 = modal.getAttribute('data-mt-modal-grupo');
        var v2 = elegir.getAttribute('data-mt-modal-elegir');
        var pil2 = estudio.querySelector('[data-mt-grupo="' + g2 + '"] [data-mt-eleccion="' + CSS.escape(v2) + '"]');
        if (pil2) pil2.click();
        cerrarModales();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrarModales(); cerrarTour(); cerrarMenu(); }
    });

    /* Guardián de salida RETIRADO (2026-08-10): el avance se guarda solo en
       cada paso (guardarEstadoCompleto en ir/irSub) y las selecciones en cada
       clic — salir y volver ya no pierde nada, el modal solo estorbaba */

    /* ───────── Ficha de pago: extras y pop ups de detalle ───────── */
    function pintarExtrasFicha() {
      var fila = estudio.querySelector('[data-mt-fila-extras]');
      var destino = estudio.querySelector('[data-mt-res-extras]');
      if (!fila || !destino) return;
      var ex = extrasElegidos();
      if (!ex.length) { fila.hidden = true; return; }
      var placa = estudio.querySelector('[data-mt-placa-texto]');
      var texto = ex.map(function (x) {
        if (x.nombre === 'Placa con nombre' && placa && placa.value.trim()) {
          return 'Placa: “' + placa.value.trim() + '”';
        }
        return x.nombre;
      }).join(' · ');
      destino.textContent = texto;
      fila.hidden = false;
    }
    estudio.addEventListener('click', function (e) {
      var ver = e.target.closest('[data-mt-ver-detalle]');
      if (!ver) return;
      var nodo = estudio.querySelector('[data-mt-detalle="' + ver.getAttribute('data-mt-ver-detalle') + '"]');
      if (nodo) {
        abrirModal(nodo.getAttribute('data-mt-detalle-titulo') || 'Detalle',
          '<p class="mt-modal-estudio__texto" style="margin:0;">' + nodo.textContent.trim() + '</p>');
      }
    });

    /* ───────── Zoom de lupa en la imagen del pedido ───────── */
    var zoomCaja = estudio.querySelector('[data-mt-zoom]');
    if (zoomCaja) {
      var zoomImg = zoomCaja.querySelector('img');
      zoomCaja.addEventListener('mousemove', function (e) {
        var r = zoomCaja.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        zoomImg.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      });
      zoomCaja.addEventListener('mouseenter', function () { zoomCaja.classList.add('mt-zoom'); });
      zoomCaja.addEventListener('mouseleave', function () {
        zoomCaja.classList.remove('mt-zoom');
        zoomImg.style.transformOrigin = 'center center';
      });
      /* En táctil no hay hover: al tocar se abre grande en el modal */
      zoomCaja.addEventListener('click', function () {
        if (esEscritorio.matches) return;
        abrirModal('Tu diseño', '<div class="mt-modal-estudio__rejilla mt-modal-estudio__rejilla--una"><img style="width:100%;border-radius:16px;" src="' + zoomImg.src + '" alt="Tu diseño"></div>');
      });
    }

    /* ───────── Divisor arrastrable entre lienzo y tarjeta ───────── */
    (function divisorArrastrable() {
      var cuerpo = estudio.querySelector('.mt-estudio__cuerpo');
      var tarjeta = estudio.querySelector('[data-mt-tarjeta]');
      if (!cuerpo || !tarjeta) return;

      var divisor = document.createElement('div');
      divisor.className = 'mt-divisor';
      divisor.setAttribute('role', 'separator');
      divisor.setAttribute('aria-orientation', 'vertical');
      divisor.setAttribute('aria-label', 'Ajustar el ancho del panel');
      divisor.tabIndex = 0;
      cuerpo.insertBefore(divisor, tarjeta);

      var MIN = 220, MAX = 480;
      var guardado = LS.get('mtEstudioPanel', null);
      if (guardado) cuerpo.style.setProperty('--mt-panel-ancho', guardado + 'px');

      function fijar(px) {
        var v = Math.max(MIN, Math.min(MAX, Math.round(px)));
        cuerpo.style.setProperty('--mt-panel-ancho', v + 'px');
        LS.set('mtEstudioPanel', v);
      }
      function alMover(ev) {
        var x = ev.touches ? ev.touches[0].clientX : ev.clientX;
        fijar(cuerpo.getBoundingClientRect().right - x - 9);
      }
      function alSoltar() {
        divisor.classList.remove('mt-arrastrando');
        document.body.classList.remove('mt-redimensionando');
        document.removeEventListener('mousemove', alMover);
        document.removeEventListener('mouseup', alSoltar);
        document.removeEventListener('touchmove', alMover);
        document.removeEventListener('touchend', alSoltar);
      }
      function alAgarrar(ev) {
        ev.preventDefault();
        divisor.classList.add('mt-arrastrando');
        document.body.classList.add('mt-redimensionando');
        document.addEventListener('mousemove', alMover);
        document.addEventListener('mouseup', alSoltar);
        document.addEventListener('touchmove', alMover, { passive: false });
        document.addEventListener('touchend', alSoltar);
      }
      divisor.addEventListener('mousedown', alAgarrar);
      divisor.addEventListener('touchstart', alAgarrar, { passive: false });
      /* Teclado: flechas mueven, doble clic restaura */
      divisor.addEventListener('keydown', function (ev) {
        var actual = parseInt(getComputedStyle(cuerpo).getPropertyValue('--mt-panel-ancho'), 10) || 300;
        if (ev.key === 'ArrowLeft') { fijar(actual + 16); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { fijar(actual - 16); ev.preventDefault(); }
      });
      divisor.addEventListener('dblclick', function () { fijar(300); });
    })();

    /* ───────── Menú lateral de la tienda (hamburguesa) ───────── */
    var menu = estudio.querySelector('[data-mt-menu]');
    function cerrarMenu() { if (menu && !menu.hidden) { menu.hidden = true; document.documentElement.style.overflow = ''; } }
    estudio.addEventListener('click', function (e) {
      if (e.target.closest('[data-mt-menu-abrir]')) {
        menu.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-mt-menu-cerrar]')) cerrarMenu();
    });

    /* ───────── Velo oscurecedor para hovers/popovers ───────── */
    var velo = estudio.querySelector('[data-mt-velo]');
    function pintarVelo() {
      if (!velo) return;
      var peekAbierto = peek && !peek.hidden;
      var invitaAbierta = invita && !invita.hidden;
      velo.hidden = !(peekAbierto || invitaAbierta);
    }

    /* ───────── Tarjeta expandible (móvil) ───────── */
    var toggleTarjeta = estudio.querySelector('[data-mt-tarjeta-toggle]');
    if (toggleTarjeta) {
      toggleTarjeta.addEventListener('click', function () {
        estudio.querySelector('[data-mt-tarjeta]').classList.toggle('mt-abierta');
      });
    }

    /* ───────── Popover flotante (escritorio) ───────── */
    var peek = estudio.querySelector('[data-mt-peek]');
    var peekTimer = null;
    var esEscritorio = window.matchMedia('(min-width: 861px)');
    function ocultarPeek() { if (peek) { peek.hidden = true; pintarVelo(); } }
    estudio.addEventListener('mouseover', function (e) {
      if (!peek || !esEscritorio.matches) return;
      var pil = e.target.closest('[data-mt-grupo="Tipo"] .mt-pildora, [data-mt-grupo="Estilo"] .mt-pildora, .mt-pildora--multi');
      clearTimeout(peekTimer);
      if (!pil) { ocultarPeek(); return; }
      peekTimer = setTimeout(function () {
        var nodo;
        if (pil.hasAttribute('data-mt-proximamente')) {
          nodo = infoNodo('Color', 'Multicolor');
        } else {
          var grupo = pil.closest('[data-mt-grupo]').getAttribute('data-mt-grupo');
          nodo = infoNodo(grupo, pil.getAttribute('data-mt-eleccion'));
        }
        if (!nodo || !nodo.textContent.trim()) return;
        peek.innerHTML = tarjetaInfoHTML(nodo, false);
        peek.style.visibility = 'hidden';
        peek.hidden = false;
        var r = pil.getBoundingClientRect();
        var pw = 280;
        var x = Math.max(12, Math.min(window.innerWidth - pw - 12, r.left + r.width / 2 - pw / 2));
        peek.style.left = x + 'px';
        var alto = peek.offsetHeight || 300;
        peek.style.top = (r.top - alto - 12 > 12 ? r.top - alto - 12 : r.bottom + 12) + 'px';
        peek.style.visibility = '';
        pintarVelo();
      }, 160);
    });
    estudio.addEventListener('mouseleave', ocultarPeek);
    window.addEventListener('scroll', ocultarPeek, { passive: true });

    /* ───────── Tour guiado (con consentimiento) ───────── */
    var tour = estudio.querySelector('[data-mt-tour]');
    var TOUR_PASOS = [
      { sel: '[data-mt-stepper]', t: 'Tu ruta en 3 pasos', d: 'Crea tu personaje, confirma tu pedido y sigue su producción hasta tu puerta.' },
      { sel: '.mt-estudio__opciones', t: 'Elige tu base', d: 'Tipo, estilo, tamaño y color. Toca "¿Cuál elijo?" en cada categoría para comparar con ejemplos.' },
      { sel: '[data-mt-tarjeta]', t: 'Tu pieza y tu avance', d: 'Tus elecciones, el precio y el botón para continuar viven aquí, siempre a la vista.' },
      { sel: '.mt-estudio__barra-der', t: 'Créditos de diseño', d: 'Tienes 3 de prueba. Crea tu cuenta gratis y recibe 3 más para seguir diseñando.' }
    ];
    var tourIdx = 0;
    function pintarTour() {
      var paso = TOUR_PASOS[tourIdx];
      var objetivo = estudio.querySelector(paso.sel);
      if (!objetivo || !objetivo.getBoundingClientRect().width) { siguienteTour(); return; }
      objetivo.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      var r = objetivo.getBoundingClientRect();
      var foco = tour.querySelector('[data-mt-tour-foco]');
      foco.style.left = (r.left - 8) + 'px';
      foco.style.top = (r.top - 8) + 'px';
      foco.style.width = (r.width + 16) + 'px';
      foco.style.height = (r.height + 16) + 'px';
      tour.querySelector('[data-mt-tour-paso]').textContent = (tourIdx + 1) + ' de ' + TOUR_PASOS.length;
      tour.querySelector('[data-mt-tour-titulo]').textContent = paso.t;
      tour.querySelector('[data-mt-tour-texto]').textContent = paso.d;
      tour.querySelector('[data-mt-tour-seguir]').textContent = tourIdx === TOUR_PASOS.length - 1 ? 'Entendido ✦' : 'Siguiente';
      var tarjeta = tour.querySelector('[data-mt-tour-tarjeta]');
      var tw = Math.min(340, window.innerWidth - 24);
      var x = Math.max(12, Math.min(window.innerWidth - tw - 12, r.left + r.width / 2 - tw / 2));
      tarjeta.style.left = x + 'px';
      var th = tarjeta.offsetHeight || 180;
      tarjeta.style.top = (r.bottom + 14 + th < window.innerHeight ? r.bottom + 14 : Math.max(12, r.top - th - 14)) + 'px';
    }
    function iniciarTour() {
      if (!tour) return;
      tourIdx = 0;
      /* sin flash: posicionar ANTES de mostrar y sin transición inicial */
      var tj = tour.querySelector('[data-mt-tour-tarjeta]');
      var fo = tour.querySelector('[data-mt-tour-foco]');
      tj.style.transition = 'none';
      fo.style.transition = 'none';
      tj.style.opacity = '0';
      tour.hidden = false;
      pintarTour();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          tj.style.transition = '';
          fo.style.transition = '';
          tj.style.opacity = '';
        });
      });
    }
    function siguienteTour() {
      tourIdx += 1;
      if (tourIdx >= TOUR_PASOS.length) { cerrarTour(); return; }
      pintarTour();
    }
    function cerrarTour() {
      if (!tour || tour.hidden) return;
      tour.hidden = true;
    }
    if (tour) {
      tour.querySelector('[data-mt-tour-seguir]').addEventListener('click', siguienteTour);
      tour.querySelector('[data-mt-tour-saltar]').addEventListener('click', cerrarTour);
      window.addEventListener('resize', function () { if (!tour.hidden) pintarTour(); });
    }
    var btnTour = estudio.querySelector('[data-mt-abrir-tour]');
    if (btnTour) btnTour.addEventListener('click', iniciarTour);

    /* Invitación con consentimiento (una sola vez) */
    var invita = estudio.querySelector('[data-mt-tour-invita]');
    function marcarTourVisto() { try { localStorage.setItem('mtEstudioTourV2', '1'); } catch (e) {} }
    var tourVisto = false;
    try { tourVisto = localStorage.getItem('mtEstudioTourV2') === '1'; } catch (e) {}
    if (invita && !tourVisto && !(window.Shopify && window.Shopify.designMode)) {
      /* La invitación al tour aparece tras un PAR DE SCROLLS (señal de interés real),
         con respaldo a los 20 s para quien explora sin scrollear. Nunca al aterrizar. */
      var invitaMostrada = false;
      var scrollsVistos = 0;
      var ultimoY = window.scrollY || 0;
      function mostrarInvita() {
        if (invitaMostrada) return;
        if (document.querySelector('[data-mt-demo]:not([hidden])')) return; /* no encimar el demo */
        invitaMostrada = true;
        invita.hidden = false;
        pintarVelo();
        window.removeEventListener('scroll', vigilarScroll);
      }
      function vigilarScroll() {
        var y = window.scrollY || 0;
        if (Math.abs(y - ultimoY) > 120) { scrollsVistos += 1; ultimoY = y; }
        if (scrollsVistos >= 2) mostrarInvita();
      }
      window.addEventListener('scroll', vigilarScroll, { passive: true });
      setTimeout(mostrarInvita, 20000);
      invita.querySelector('[data-mt-invita-si]').addEventListener('click', function () {
        invita.hidden = true;
        marcarTourVisto();
        pintarVelo();
        iniciarTour();
      });
      invita.querySelector('[data-mt-invita-no]').addEventListener('click', function () {
        invita.hidden = true;
        marcarTourVisto();
        pintarVelo();
      });
    }

    /* ───────── Demo giratorio ───────── */
    function heroEmpezar() {
      if (!faltantes().length) { irSub('fotos'); return; } /* ya eligió todo: directo a las fotos */
      var destino = estudio.querySelector('[data-mt-grupo="Tipo"]');
      if (!destino) return;
      var campo = destino.closest('.mt-estudio__campo') || destino;
      campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      campo.classList.add('mt-pulso-oro');
      setTimeout(function () { campo.classList.remove('mt-pulso-oro'); }, 2400);
    }

    var demo = estudio.querySelector('[data-mt-demo]');
    if (demo) {
      var demoImg = demo.querySelector('[data-mt-demo-giro]');
      var demoTimer = null;
      var demoFrame = 0;
      var DEMO_FRAMES = 72; /* mt-giro-000 … mt-giro-071 */
      function pasoDemo() {
        if (demo.hidden) return;
        demoFrame = (demoFrame + 2) % DEMO_FRAMES;
        var sig = demoImg.src.replace(/mt-giro-\d+/, 'mt-giro-' + ('00' + demoFrame).slice(-3));
        var pre = new Image();
        /* solo se muestra un fotograma ya cargado: sin huecos en conexiones lentas */
        pre.onload = function () { if (demo.hidden) { demoTimer = null; return; } demoImg.src = sig; demoTimer = setTimeout(pasoDemo, 80); };
        pre.onerror = function () { if (demo.hidden) { demoTimer = null; return; } demoTimer = setTimeout(pasoDemo, 80); };
        pre.src = sig;
      }
      function abrirDemo() {
        demo.hidden = false;
        if (demoTimer) return;
        pasoDemo();
      }
      function cerrarDemo() {
        demo.hidden = true;
        if (demoTimer) { clearTimeout(demoTimer); demoTimer = null; }
      }
      var abridores = estudio.querySelectorAll('[data-mt-abrir-demo]');
      for (var iD = 0; iD < abridores.length; iD++) abridores[iD].addEventListener('click', abrirDemo);
      var cerradores = demo.querySelectorAll('[data-mt-demo-cerrar]');
      for (var jD = 0; jD < cerradores.length; jD++) cerradores[jD].addEventListener('click', cerrarDemo);
      var demoCta = demo.querySelector('[data-mt-demo-empezar]');
      if (demoCta) demoCta.addEventListener('click', function () { cerrarDemo(); heroEmpezar(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarDemo(); });
    }

    /* Al volver a la pestaña (el móvil congela timers): consultar el estado al instante */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible' || !CEREBRO || !estado.idDiseno) return;
      if (estado.sub1 === 'generando' && !estado.propuestaLista) {
        fetch(api('/estado/' + estado.idDiseno)).then(function (r) { return r.json(); })
          .then(function (d) {
            if (d.estado === 'imagen_lista' && d.url_imagen) {
              aplicarPropuesta(urlConInvitado(d.url_imagen));
              estado.propuestaLista = true;
              marcarDiseno();
              estado.sub1 = 'detalles';
              guardarEstadoCompleto();
              sincronizarCreditos();
              cerrarModales();
              ir(2);
            }
          }).catch(function () {});
      }
      if (estado.paso === 2 && !estado.pagado) consultarPago();
    });

    /* Punto dorado en "Mi Estudio": hay una figura lista sin comprar */
    function pintarPuntoListo() {
      var hay = !!(estado.propuestaLista && !estado.pagado);
      try { localStorage.setItem('mtFiguraLista', hay ? '1' : '0'); } catch (e) {}
      document.querySelectorAll('a[href*="/pages/mi-estudio"]').forEach(function (a) {
        a.classList.toggle('mt-tiene-lista', hay);
      });
    }
    var __pl = pintar;
    pintar = function () { __pl(); pintarPuntoListo(); };

    /* ───────── Arranque ───────── */
    restaurarSelecciones();
    ajustarListaPose(); /* poses vs gestos según el Tipo restaurado */
    ajustarReglasSeleccion();
    /* Adopción: los diseños creados como invitado en este navegador pasan a la
       cuenta al iniciar sesión (el worker solo mueve diseños, no créditos) */
    if (cuenta && CEREBRO) {
      var vInvitado = LS.get('mtEstudioVisitante', null);
      if (vInvitado) {
        fetch(API_BASE + '/migrar?invitado=' + encodeURIComponent(vInvitado))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            LS.del('mtEstudioVisitante');
            if (d && d.migrados > 0) { sincronizarCreditos(); cargarHistorial(); }
          })
          .catch(function () {});
      }
    }
    sincronizarCreditos(); /* el contador real vive en el cerebro */
    pintarTagsCaja();
    var huboEstado = restaurarEstadoCompleto();
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) {}
    if (params && params.get('retomar') && CEREBRO) {
      var idRetomar = params.get('retomar');
      fetch(api('/disenos'))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var x = ((d && d.disenos) || []).filter(function (i) { return i.id === idRetomar; })[0];
          if (x) { historialCache[x.id] = x; aplicarRetomar(x); }
        })
        .catch(function () {});
    }
    if (params && params.get('pago') === 'ok') {
      if (!estado.propuestaLista) { estado.propuestaLista = true; marcarDiseno(); }
      estado.maxPaso = Math.max(estado.maxPaso, 2);
      ir(2);
      if (CEREBRO) { subpantalla(2, 'esperando'); vigilarPago(); }
      else { estado.pagado = true; setTimeout(function () { ir(4); }, reduceMotion ? 300 : 1600); }
    } else if (!huboEstado) {
      pintar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
